"use es6";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign$ = function __assign$1() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign$.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __values$1(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$1(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var AMPLITUDE_PREFIX = 'AMP';
var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
var EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
var AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
var EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch';

/** The status of an event. */
var Status$1;
(function (Status) {
  /** The status could not be determined. */
  Status["Unknown"] = "unknown";
  /** The event was skipped due to configuration or callbacks. */
  Status["Skipped"] = "skipped";
  /** The event was sent successfully. */
  Status["Success"] = "success";
  /** A user or device in the payload is currently rate limited and should try again later. */
  Status["RateLimit"] = "rate_limit";
  /** The sent payload was too large to be processed. */
  Status["PayloadTooLarge"] = "payload_too_large";
  /** The event could not be processed. */
  Status["Invalid"] = "invalid";
  /** A server-side error ocurred during submission. */
  Status["Failed"] = "failed";
  /** a server or client side error occuring when a request takes too long and is cancelled */
  Status["Timeout"] = "Timeout";
  /** NodeJS runtime environment error.. E.g. disconnected from network */
  Status["SystemError"] = "SystemError";
})(Status$1 || (Status$1 = {}));

/* eslint-disable no-restricted-globals */
/* Only file allowed to access to globalThis, window, self */
var getGlobalScope = function getGlobalScope() {
  // This should only be used for integrations with Amplitude that are not running in a browser environment
  //   We need to specify the name of the global variable as a string to prevent it from being minified
  var ampIntegrationContextName = 'ampIntegrationContext';
  if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') {
    return globalThis[ampIntegrationContextName];
  }
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  return undefined;
};
var returnWrapper = function returnWrapper(awaitable) {
  return {
    promise: awaitable || Promise.resolve()
  };
};
var LogLevel;
(function (LogLevel) {
  LogLevel[LogLevel["None"] = 0] = "None";
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Warn"] = 2] = "Warn";
  LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
  LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));
var PREFIX = 'Amplitude Logger ';
var Logger = /** @class */function () {
  function Logger() {
    this.logLevel = LogLevel.None;
  }
  Logger.prototype.disable = function () {
    this.logLevel = LogLevel.None;
  };
  Logger.prototype.enable = function (logLevel) {
    if (logLevel === void 0) {
      logLevel = LogLevel.Warn;
    }
    this.logLevel = logLevel;
  };
  Logger.prototype.log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Verbose) {
      return;
    }
    console.log("".concat(PREFIX, "[Log]: ").concat(args.join(' ')));
  };
  Logger.prototype.warn = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Warn) {
      return;
    }
    console.warn("".concat(PREFIX, "[Warn]: ").concat(args.join(' ')));
  };
  Logger.prototype.error = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Error) {
      return;
    }
    console.error("".concat(PREFIX, "[Error]: ").concat(args.join(' ')));
  };
  Logger.prototype.debug = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.logLevel < LogLevel.Debug) {
      return;
    }
    // console.debug output is hidden by default in chrome
    console.log("".concat(PREFIX, "[Debug]: ").concat(args.join(' ')));
  };
  return Logger;
}();
var getDefaultConfig$1 = function getDefaultConfig$1() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 10000,
    instanceName: '$default_instance',
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    offline: false,
    optOut: false,
    serverUrl: AMPLITUDE_SERVER_URL,
    serverZone: 'US',
    useBatch: false
  };
};
var Config = /** @class */function () {
  function Config(options) {
    var _a, _b, _c, _d;
    this._optOut = false;
    var defaultConfig = getDefaultConfig$1();
    this.apiKey = options.apiKey;
    this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
    this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
    this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
    this.instanceName = options.instanceName || defaultConfig.instanceName;
    this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
    this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
    this.minIdLength = options.minIdLength;
    this.plan = options.plan;
    this.ingestionMetadata = options.ingestionMetadata;
    this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
    this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
    this.serverUrl = options.serverUrl;
    this.serverZone = options.serverZone || defaultConfig.serverZone;
    this.storageProvider = options.storageProvider;
    this.transportProvider = options.transportProvider;
    this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
    this.loggerProvider.enable(this.logLevel);
    var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
    this.serverZone = serverConfig.serverZone;
    this.serverUrl = serverConfig.serverUrl;
  }
  Object.defineProperty(Config.prototype, "optOut", {
    get: function () {
      return this._optOut;
    },
    set: function (optOut) {
      this._optOut = optOut;
    },
    enumerable: false,
    configurable: true
  });
  return Config;
}();
var getServerUrl$1 = function getServerUrl$1(serverZone, useBatch) {
  if (serverZone === 'EU') {
    return useBatch ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL;
  }
  return useBatch ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL;
};
var createServerConfig = function createServerConfig(serverUrl, serverZone, useBatch) {
  if (serverUrl === void 0) {
    serverUrl = '';
  }
  if (serverZone === void 0) {
    serverZone = getDefaultConfig$1().serverZone;
  }
  if (useBatch === void 0) {
    useBatch = getDefaultConfig$1().useBatch;
  }
  if (serverUrl) {
    return {
      serverUrl: serverUrl,
      serverZone: undefined
    };
  }
  var _serverZone = ['US', 'EU'].includes(serverZone) ? serverZone : getDefaultConfig$1().serverZone;
  return {
    serverZone: _serverZone,
    serverUrl: getServerUrl$1(_serverZone, useBatch)
  };
};
var ApplicationContextProviderImpl = /** @class */function () {
  function ApplicationContextProviderImpl() {}
  ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
    return {
      versionName: this.versionName,
      language: getLanguage(),
      platform: 'Web',
      os: undefined,
      deviceModel: undefined
    };
  };
  return ApplicationContextProviderImpl;
}();
var getLanguage = function getLanguage() {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */function () {
  function EventBridgeImpl() {
    this.queue = [];
  }
  EventBridgeImpl.prototype.logEvent = function (event) {
    if (!this.receiver) {
      if (this.queue.length < 512) {
        this.queue.push(event);
      }
    } else {
      this.receiver(event);
    }
  };
  EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
    this.receiver = receiver;
    if (this.queue.length > 0) {
      this.queue.forEach(function (event) {
        receiver(event);
      });
      this.queue = [];
    }
  };
  return EventBridgeImpl;
}();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function isEqual(obj1, obj2) {
  var e_1, _a;
  var primitive = ['string', 'number', 'boolean', 'undefined'];
  var typeA = typeof obj1;
  var typeB = typeof obj2;
  if (typeA !== typeB) {
    return false;
  }
  try {
    for (var primitive_1 = __values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()) {
      var p = primitive_1_1.value;
      if (p === typeA) {
        return obj1 === obj2;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  // check null
  if (obj1 == null && obj2 == null) {
    return true;
  } else if (obj1 == null || obj2 == null) {
    return false;
  }
  // if got here - objects
  if (obj1.length !== obj2.length) {
    return false;
  }
  //check if arrays
  var isArrayA = Array.isArray(obj1);
  var isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA && isArrayB) {
    //arrays
    for (var i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    //objects
    var sorted1 = Object.keys(obj1).sort();
    var sorted2 = Object.keys(obj2).sort();
    if (!isEqual(sorted1, sorted2)) {
      return false;
    }
    //compare object values
    var result_1 = true;
    Object.keys(obj1).forEach(function (key) {
      if (!isEqual(obj1[key], obj2[key])) {
        result_1 = false;
      }
    });
    return result_1;
  }
  return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}
var IdentityStoreImpl = /** @class */function () {
  function IdentityStoreImpl() {
    this.identity = {
      userProperties: {}
    };
    this.listeners = new Set();
  }
  IdentityStoreImpl.prototype.editIdentity = function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    var actingUserProperties = _assign({}, this.identity.userProperties);
    var actingIdentity = _assign(_assign({}, this.identity), {
      userProperties: actingUserProperties
    });
    return {
      setUserId: function (userId) {
        actingIdentity.userId = userId;
        return this;
      },
      setDeviceId: function (deviceId) {
        actingIdentity.deviceId = deviceId;
        return this;
      },
      setUserProperties: function (userProperties) {
        actingIdentity.userProperties = userProperties;
        return this;
      },
      setOptOut: function (optOut) {
        actingIdentity.optOut = optOut;
        return this;
      },
      updateUserProperties: function (actions) {
        var e_1, _a, e_2, _b, e_3, _c;
        var actingProperties = actingIdentity.userProperties || {};
        try {
          for (var _d = __values(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var _f = __read(_e.value, 2),
              action = _f[0],
              properties = _f[1];
            switch (action) {
              case ID_OP_SET:
                try {
                  for (var _g = (e_2 = void 0, __values(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var _j = __read(_h.value, 2),
                      key = _j[0],
                      value = _j[1];
                    actingProperties[key] = value;
                  }
                } catch (e_2_1) {
                  e_2 = {
                    error: e_2_1
                  };
                } finally {
                  try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                  } finally {
                    if (e_2) throw e_2.error;
                  }
                }
                break;
              case ID_OP_UNSET:
                try {
                  for (var _k = (e_3 = void 0, __values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var key = _l.value;
                    delete actingProperties[key];
                  }
                } catch (e_3_1) {
                  e_3 = {
                    error: e_3_1
                  };
                } finally {
                  try {
                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                  } finally {
                    if (e_3) throw e_3.error;
                  }
                }
                break;
              case ID_OP_CLEAR_ALL:
                actingProperties = {};
                break;
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        actingIdentity.userProperties = actingProperties;
        return this;
      },
      commit: function () {
        self.setIdentity(actingIdentity);
        return this;
      }
    };
  };
  IdentityStoreImpl.prototype.getIdentity = function () {
    return _assign({}, this.identity);
  };
  IdentityStoreImpl.prototype.setIdentity = function (identity) {
    var originalIdentity = _assign({}, this.identity);
    this.identity = _assign({}, identity);
    if (!isEqual(originalIdentity, this.identity)) {
      this.listeners.forEach(function (listener) {
        listener(identity);
      });
    }
  };
  IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
    this.listeners.add(listener);
  };
  IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
    this.listeners.delete(listener);
  };
  return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
var AnalyticsConnector = /** @class */function () {
  function AnalyticsConnector() {
    this.identityStore = new IdentityStoreImpl();
    this.eventBridge = new EventBridgeImpl();
    this.applicationContextProvider = new ApplicationContextProviderImpl();
  }
  AnalyticsConnector.getInstance = function (instanceName) {
    if (!safeGlobal['analyticsConnectorInstances']) {
      safeGlobal['analyticsConnectorInstances'] = {};
    }
    if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
      safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
    }
    return safeGlobal['analyticsConnectorInstances'][instanceName];
  };
  return AnalyticsConnector;
}();
var getAnalyticsConnector = function getAnalyticsConnector(instanceName) {
  if (instanceName === void 0) {
    instanceName = '$default_instance';
  }
  return AnalyticsConnector.getInstance(instanceName);
};
var getStacktrace = function getStacktrace(ignoreDepth) {
  var trace = new Error().stack || '';
  return trace.split('\n').slice(2 + ignoreDepth).map(function (text) {
    return text.trim();
  });
};
var debugWrapper = function debugWrapper(fn, fnName, getLogConfig, getStates, fnContext) {
  if (fnContext === void 0) {
    fnContext = null;
  }
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _a = getLogConfig(),
      logger = _a.logger,
      logLevel = _a.logLevel;
    // return early if possible to reduce overhead
    if (logLevel && logLevel < LogLevel.Debug || !logLevel || !logger) {
      return fn.apply(fnContext, args);
    }
    var debugContext = {
      type: 'invoke public method',
      name: fnName,
      args: args,
      stacktrace: getStacktrace(1),
      time: {
        start: new Date().toISOString()
      },
      states: {}
    };
    var result = fn.apply(fnContext, args);
    if (result && result.promise) {
      // if result is a promise, add the callback
      result.promise.then(function () {
        if (debugContext.time) {
          debugContext.time.end = new Date().toISOString();
        }
        logger.debug(JSON.stringify(debugContext, null, 2));
      });
    } else {
      if (debugContext.time) {
        debugContext.time.end = new Date().toISOString();
      }
      logger.debug(JSON.stringify(debugContext, null, 2));
    }
    return result;
  };
};
var BaseTransport$1 = /** @class */function () {
  function BaseTransport() {}
  BaseTransport.prototype.send = function (_serverUrl, _payload) {
    return Promise.resolve(null);
  };
  BaseTransport.prototype.buildResponse = function (responseJSON) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    if (typeof responseJSON !== 'object') {
      return null;
    }
    var statusCode = responseJSON.code || 0;
    var status = this.buildStatus(statusCode);
    switch (status) {
      case Status$1.Success:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
            payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
            serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
          }
        };
      case Status$1.Invalid:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
            missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
            eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
            eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
            eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
            epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
            exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
            silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
            silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
            throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
            throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
          }
        };
      case Status$1.PayloadTooLarge:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
          }
        };
      case Status$1.RateLimit:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
            epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
            throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
            throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
            exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
            exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
            throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
          }
        };
      case Status$1.Timeout:
      default:
        return {
          status: status,
          statusCode: statusCode
        };
    }
  };
  BaseTransport.prototype.buildStatus = function (code) {
    if (code >= 200 && code < 300) {
      return Status$1.Success;
    }
    if (code === 429) {
      return Status$1.RateLimit;
    }
    if (code === 413) {
      return Status$1.PayloadTooLarge;
    }
    if (code === 408) {
      return Status$1.Timeout;
    }
    if (code >= 400 && code < 500) {
      return Status$1.Invalid;
    }
    if (code >= 500) {
      return Status$1.Failed;
    }
    return Status$1.Unknown;
  };
  return BaseTransport;
}();
var FetchTransport = /** @class */function (_super) {
  __extends(FetchTransport, _super);
  function FetchTransport() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FetchTransport.prototype.send = function (serverUrl, payload) {
    return __awaiter(this, void 0, void 0, function () {
      var options, response, responseText;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            /* istanbul ignore if */
            if (typeof fetch === 'undefined') {
              throw new Error('FetchTransport is not supported');
            }
            options = {
              headers: {
                'Content-Type': 'application/json',
                Accept: '*/*'
              },
              body: JSON.stringify(payload),
              method: 'POST'
            };
            return [4 /*yield*/, fetch(serverUrl, options)];
          case 1:
            response = _a.sent();
            return [4 /*yield*/, response.text()];
          case 2:
            responseText = _a.sent();
            try {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              return [2 /*return*/, this.buildResponse(JSON.parse(responseText))];
            } catch (_b) {
              return [2 /*return*/, this.buildResponse({
                code: response.status
              })];
            }
            return [2 /*return*/];
        }
      });
    });
  };
  return FetchTransport;
}(BaseTransport$1);

/**
 * @deprecated use ServerZoneType instead
 */
var ServerZone$1;
(function (ServerZone) {
  ServerZone["US"] = "US";
  ServerZone["EU"] = "EU";
  /**
   * Add for session-replay-browser migration from analytics-type v1.x.
   */
  ServerZone["STAGING"] = "STAGING";
})(ServerZone$1 || (ServerZone$1 = {}));
var DEFAULT_EVENT_PROPERTY_PREFIX = '[Amplitude]';
var DEFAULT_SESSION_REPLAY_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay ID");
var DEFAULT_SAMPLE_RATE = 0;
var DEFAULT_SERVER_ZONE = ServerZone$1.US;
var DEFAULT_PERFORMANCE_CONFIG = {
  enabled: true
};
var DEFAULT_URL_CHANGE_POLLING_INTERVAL = 1000;
var SESSION_REPLAY_DEBUG_PROPERTY = "".concat(DEFAULT_EVENT_PROPERTY_PREFIX, " Session Replay Debug");
var BLOCK_CLASS = 'amp-block';
var MASK_TEXT_CLASS = 'amp-mask';
var UNMASK_TEXT_CLASS = 'amp-unmask';
var SESSION_REPLAY_SERVER_URL = 'https://api-sr.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_EU_URL = 'https://api-sr.eu.amplitude.com/sessions/v2/track';
var SESSION_REPLAY_STAGING_URL = 'https://api-sr.stag2.amplitude.com/sessions/v2/track';
var MAX_EVENT_LIST_SIZE = 1 * 1000000; // ~1 MB limit for JSON serialized events payload
var INTERACTION_MIN_INTERVAL = 30000; // 30 seconds
var INTERACTION_MAX_INTERVAL = 60000; // 1 minute
var MIN_INTERVAL = 500; // 500 ms
var MAX_INTERVAL = 10 * 1000; // 10 seconds
var KB_SIZE = 1024;
var MAX_URL_LENGTH = 1000;
var CustomRRwebEvent;
(function (CustomRRwebEvent) {
  CustomRRwebEvent["GET_SR_PROPS"] = "get-sr-props";
  CustomRRwebEvent["DEBUG_INFO"] = "debug-info";
  CustomRRwebEvent["FETCH_REQUEST"] = "fetch-request";
  CustomRRwebEvent["METADATA"] = "metadata";
})(CustomRRwebEvent || (CustomRRwebEvent = {}));
var SafeLoggerProvider = /** @class */function () {
  function SafeLoggerProvider(loggerProvider) {
    this.logger = loggerProvider;
    this.log = this.getSafeMethod('log');
    this.warn = this.getSafeMethod('warn');
    this.error = this.getSafeMethod('error');
    this.debug = this.getSafeMethod('debug');
  }
  SafeLoggerProvider.prototype.getSafeMethod = function (method) {
    var _a;
    if (!this.logger) {
      return function () {
        // No-op function fallback
      };
    }
    var fn = this.logger[method];
    if (typeof fn === 'function') {
      var originalFn = (_a = fn.__rrweb_original__) !== null && _a !== void 0 ? _a : fn;
      return originalFn.bind(this.logger);
    }
    return function () {
      // No-op function fallback
    };
  };
  SafeLoggerProvider.prototype.enable = function (logLevel) {
    this.logger.enable(logLevel);
  };
  SafeLoggerProvider.prototype.disable = function () {
    this.logger.disable();
  };
  return SafeLoggerProvider;
}();
var DEFAULT_MASK_LEVEL = 'medium';
function toLowerCase(str) {
  return str.toLowerCase();
}
/**
 * Get the type of an input element.
 * This takes care of the case where a password input is changed to a text input.
 * In this case, we continue to consider this of type password, in order to avoid leaking sensitive data
 * where passwords should be masked.
 */
function getInputType(element) {
  // when omitting the type of input element(e.g. <input />), the type is treated as text
  var type = element.type;
  return element.hasAttribute('data-rr-is-password') ? 'password' : type ?
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  toLowerCase(type) : null;
}

/**
 * Light: Subset of inputs
 * Medium: All inputs
 * Conservative: All inputs and all texts
 */
var isMaskedForLevel = function isMaskedForLevel(elementType, level, element) {
  switch (level) {
    case 'light':
      {
        if (elementType !== 'input') {
          return true;
        }
        var inputType = element ? getInputType(element) : '';
        /* istanbul ignore if */ // TODO(lew): For some reason it's impossible to test this.
        if (!inputType) {
          return false;
        }
        if (['password', 'hidden', 'email', 'tel'].includes(inputType)) {
          return true;
        }
        if (element.autocomplete.startsWith('cc-')) {
          return true;
        }
        return false;
      }
    case 'medium':
    case 'conservative':
      return true;
    default:
      return isMaskedForLevel(elementType, DEFAULT_MASK_LEVEL, element);
  }
};
/**
 * Checks if the given element set to be masked by rrweb
 *
 * Priority is:
 *  1. [In code] Element/class based masking/unmasking <> [Config based] Selector based masking/unmasking
 *  2. Use app defaults
 */
var isMasked = function isMasked(elementType, config, element) {
  var _a, _b, _c;
  if (config === void 0) {
    config = {
      defaultMaskLevel: DEFAULT_MASK_LEVEL
    };
  }
  if (element) {
    // Element or parent is explicitly instrumented in code to mask
    if (element.closest('.' + MASK_TEXT_CLASS)) {
      return true;
    }
    // Config has override for mask
    var shouldMask = ((_a = config.maskSelector) !== null && _a !== void 0 ? _a : []).some(function (selector) {
      return element.closest(selector);
    });
    if (shouldMask) {
      return true;
    }
    // Code or config has override to unmask
    if (element.closest('.' + UNMASK_TEXT_CLASS)) {
      return false;
    }
    // Here we are probably sent an element, but we want to match if they have a
    // parent with an unmask selector.
    var shouldUnmask = ((_b = config.unmaskSelector) !== null && _b !== void 0 ? _b : []).some(function (selector) {
      return element.closest(selector);
    });
    if (shouldUnmask) {
      return false;
    }
  }
  return isMaskedForLevel(elementType, (_c = config.defaultMaskLevel) !== null && _c !== void 0 ? _c : DEFAULT_MASK_LEVEL, element);
};
var maskFn = function maskFn(elementType, config) {
  return function (text, element) {
    return isMasked(elementType, config, element) ? text.replace(/[^\s]/g, '*') : text;
  };
};
var generateHashCode = function generateHashCode(str) {
  var hash = 0;
  if (str.length === 0) return hash;
  for (var i = 0; i < str.length; i++) {
    var chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};
var isSessionInSample = function isSessionInSample(sessionId, sampleRate) {
  var hashNumber = generateHashCode(sessionId.toString());
  var absHash = Math.abs(hashNumber);
  var absHashMultiply = absHash * 31;
  var mod = absHashMultiply % 1000000;
  return mod / 1000000 < sampleRate;
};
var getCurrentUrl = function getCurrentUrl() {
  var globalScope = getGlobalScope();
  return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) ? globalScope.location.href : '';
};
var generateSessionReplayId = function generateSessionReplayId(sessionId, deviceId) {
  return "".concat(deviceId, "/").concat(sessionId);
};
var getServerUrl = function getServerUrl(serverZone, trackServerUrl) {
  if (trackServerUrl) {
    return trackServerUrl;
  }
  if (serverZone === ServerZone$1.STAGING) {
    return SESSION_REPLAY_STAGING_URL;
  }
  if (serverZone === ServerZone$1.EU) {
    return SESSION_REPLAY_EU_URL;
  }
  return SESSION_REPLAY_SERVER_URL;
};
var isValidGlobUrl = function isValidGlobUrl(globUrl) {
  if (typeof globUrl !== 'string' || globUrl.trim() === '') return false;
  var urlPattern = /^\/|^https?:\/\/[^\s]+$/;
  if (!urlPattern.test(globUrl)) return false;
  return true;
};
var globToRegex = function globToRegex(glob) {
  // Escape special regex characters, then convert globs
  var escaped = glob.replace(/[.+^${}()|[\]\\]/g, '\\$&') // Escape regex specials
  .replace(/\*/g, '.*') // Convert * to .*
  .replace(/\?/g, '.'); // Convert ? to .
  return new RegExp("^".concat(escaped, "$"));
};
var validateUGCFilterRules = function validateUGCFilterRules(ugcFilterRules) {
  // validate ugcFilterRules
  if (!ugcFilterRules.every(function (rule) {
    return typeof rule.selector === 'string' && typeof rule.replacement === 'string';
  })) {
    throw new Error('ugcFilterRules must be an array of objects with selector and replacement properties');
  }
  // validate ugcFilterRules are valid globs
  if (!ugcFilterRules.every(function (rule) {
    return isValidGlobUrl(rule.selector);
  })) {
    throw new Error('ugcFilterRules must be an array of objects with valid globs');
  }
};
var getPageUrl = function getPageUrl(pageUrl, ugcFilterRules) {
  var e_1, _a;
  try {
    // apply ugcFilterRules, order is important, first rule wins
    for (var ugcFilterRules_1 = __values$1(ugcFilterRules), ugcFilterRules_1_1 = ugcFilterRules_1.next(); !ugcFilterRules_1_1.done; ugcFilterRules_1_1 = ugcFilterRules_1.next()) {
      var rule = ugcFilterRules_1_1.value;
      var regex = globToRegex(rule.selector);
      if (regex.test(pageUrl)) {
        return pageUrl.replace(regex, rule.replacement);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (ugcFilterRules_1_1 && !ugcFilterRules_1_1.done && (_a = ugcFilterRules_1.return)) _a.call(ugcFilterRules_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return pageUrl;
};
var getStorageSize = function getStorageSize() {
  return __awaiter(void 0, void 0, void 0, function () {
    var globalScope, _a, usage, quota, usageDetails, totalStorageSize, percentOfQuota;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 3,, 4]);
          globalScope = getGlobalScope();
          if (!globalScope) return [3 /*break*/, 2];
          return [4 /*yield*/, globalScope.navigator.storage.estimate()];
        case 1:
          _a = _b.sent(), usage = _a.usage, quota = _a.quota, usageDetails = _a.usageDetails;
          totalStorageSize = usage ? Math.round(usage / KB_SIZE) : 0;
          percentOfQuota = usage && quota ? Math.round((usage / quota + Number.EPSILON) * 1000) / 1000 : 0;
          return [2 /*return*/, {
            totalStorageSize: totalStorageSize,
            percentOfQuota: percentOfQuota,
            usageDetails: JSON.stringify(usageDetails)
          }];
        case 2:
          return [3 /*break*/, 4];
        case 3:
          _b.sent();
          return [3 /*break*/, 4];
        case 4:
          return [2 /*return*/, {
            totalStorageSize: 0,
            percentOfQuota: 0,
            usageDetails: ''
          }];
      }
    });
  });
};
var getDebugConfig = function getDebugConfig(config) {
  var debugConfig = _assign$({}, config);
  var apiKey = debugConfig.apiKey;
  debugConfig.apiKey = "****".concat(apiKey.substring(apiKey.length - 4));
  return debugConfig;
};
var getDefaultConfig = function getDefaultConfig() {
  return {
    flushMaxRetries: 2,
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    transportProvider: new FetchTransport()
  };
};
var SessionReplayLocalConfig = /** @class */function (_super) {
  __extends(SessionReplayLocalConfig, _super);
  function SessionReplayLocalConfig(apiKey, options) {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var defaultConfig = getDefaultConfig();
    _this = _super.call(this, _assign$(_assign$({
      transportProvider: defaultConfig.transportProvider,
      loggerProvider: new SafeLoggerProvider(options.loggerProvider || defaultConfig.loggerProvider)
    }, options), {
      apiKey: apiKey
    })) || this;
    _this.flushMaxRetries = options.flushMaxRetries !== undefined && options.flushMaxRetries <= defaultConfig.flushMaxRetries ? options.flushMaxRetries : defaultConfig.flushMaxRetries;
    _this.apiKey = apiKey;
    _this.sampleRate = options.sampleRate || DEFAULT_SAMPLE_RATE;
    _this.serverZone = options.serverZone || DEFAULT_SERVER_ZONE;
    _this.configServerUrl = options.configServerUrl;
    _this.trackServerUrl = options.trackServerUrl;
    _this.shouldInlineStylesheet = options.shouldInlineStylesheet;
    _this.version = options.version;
    _this.performanceConfig = options.performanceConfig || DEFAULT_PERFORMANCE_CONFIG;
    _this.storeType = (_a = options.storeType) !== null && _a !== void 0 ? _a : 'idb';
    _this.applyBackgroundColorToBlockedElements = (_b = options.applyBackgroundColorToBlockedElements) !== null && _b !== void 0 ? _b : false;
    _this.enableUrlChangePolling = (_c = options.enableUrlChangePolling) !== null && _c !== void 0 ? _c : false;
    _this.urlChangePollingInterval = (_d = options.urlChangePollingInterval) !== null && _d !== void 0 ? _d : DEFAULT_URL_CHANGE_POLLING_INTERVAL;
    _this.captureDocumentTitle = (_e = options.captureDocumentTitle) !== null && _e !== void 0 ? _e : false;
    if (options.privacyConfig) {
      _this.privacyConfig = options.privacyConfig;
    }
    if (options.interactionConfig) {
      _this.interactionConfig = options.interactionConfig;
      // validate ugcFilterRules, throw error if invalid - throw error at the beginning of the config
      if (_this.interactionConfig.ugcFilterRules) {
        validateUGCFilterRules(_this.interactionConfig.ugcFilterRules);
      }
    }
    if (options.debugMode) {
      _this.debugMode = options.debugMode;
    }
    if (options.experimental) {
      _this.experimental = options.experimental;
    }
    if (options.omitElementTags) {
      _this.omitElementTags = options.omitElementTags;
    }
    return _this;
  }
  return SessionReplayLocalConfig;
}(Config);
var EventType = /* @__PURE__ */(EventType2 => {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
})(EventType || {});
var MouseInteractions = /* @__PURE__ */(MouseInteractions2 => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions || {});
var ServerZone;
(function (ServerZone) {
  ServerZone["US"] = "US";
  ServerZone["EU"] = "EU";
  ServerZone["STAGING"] = "STAGING";
})(ServerZone || (ServerZone = {}));

/** The status of an event. */
var Status;
(function (Status) {
  /** The status could not be determined. */
  Status["Unknown"] = "unknown";
  /** The event was skipped due to configuration or callbacks. */
  Status["Skipped"] = "skipped";
  /** The event was sent successfully. */
  Status["Success"] = "success";
  /** A user or device in the payload is currently rate limited and should try again later. */
  Status["RateLimit"] = "rate_limit";
  /** The sent payload was too large to be processed. */
  Status["PayloadTooLarge"] = "payload_too_large";
  /** The event could not be processed. */
  Status["Invalid"] = "invalid";
  /** A server-side error ocurred during submission. */
  Status["Failed"] = "failed";
  /** a server or client side error occuring when a request takes too long and is cancelled */
  Status["Timeout"] = "Timeout";
  /** NodeJS runtime environment error.. E.g. disconnected from network */
  Status["SystemError"] = "SystemError";
})(Status || (Status = {}));

/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
var BaseTransport = /** @class */function () {
  function BaseTransport() {}
  BaseTransport.prototype.send = function (_serverUrl, _payload) {
    return Promise.resolve(null);
  };
  BaseTransport.prototype.buildResponse = function (responseJSON) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    if (typeof responseJSON !== 'object') {
      return null;
    }
    var statusCode = responseJSON.code || 0;
    var status = this.buildStatus(statusCode);
    switch (status) {
      case Status.Success:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
            payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
            serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
          }
        };
      case Status.Invalid:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
            missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
            eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
            eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
            eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
            epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
            exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
            silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
            silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
            throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
            throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
          }
        };
      case Status.PayloadTooLarge:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
          }
        };
      case Status.RateLimit:
        return {
          status: status,
          statusCode: statusCode,
          body: {
            error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
            epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
            throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
            throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
            exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
            exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
            throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
          }
        };
      case Status.Timeout:
      default:
        return {
          status: status,
          statusCode: statusCode
        };
    }
  };
  BaseTransport.prototype.buildStatus = function (code) {
    if (code >= 200 && code < 300) {
      return Status.Success;
    }
    if (code === 429) {
      return Status.RateLimit;
    }
    if (code === 413) {
      return Status.PayloadTooLarge;
    }
    if (code === 408) {
      return Status.Timeout;
    }
    if (code >= 400 && code < 500) {
      return Status.Invalid;
    }
    if (code >= 500) {
      return Status.Failed;
    }
    return Status.Unknown;
  };
  return BaseTransport;
}();
var UNEXPECTED_NETWORK_ERROR_MESSAGE$1 = 'Network error occurred, remote config fetch failed';
var SUCCESS_REMOTE_CONFIG = 'Remote config successfully fetched';
var MAX_RETRIES_EXCEEDED_MESSAGE$1 = 'Remote config fetch rejected due to exceeded retry count';
var TIMEOUT_MESSAGE = 'Remote config fetch rejected due to timeout after 5 seconds';
var UNEXPECTED_ERROR_MESSAGE$1 = 'Unexpected error occurred';
var REMOTE_CONFIG_SERVER_URL = 'https://sr-client-cfg.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_STAGING = 'https://sr-client-cfg.stag2.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_EU = 'https://sr-client-cfg.eu.amplitude.com/config';
var RemoteConfigFetch = /** @class */function () {
  function RemoteConfigFetch(_a) {
    var localConfig = _a.localConfig,
      configKeys = _a.configKeys;
    var _this = this;
    this.retryTimeout = 1000;
    this.attempts = 0;
    this.sessionTargetingMatch = false;
    this.metrics = {};
    this.getRemoteNamespaceConfig = function (configNamespace, sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var fetchStartTime, configAPIResponse, remoteConfig;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              fetchStartTime = Date.now();
              return [4 /*yield*/, this.fetchWithTimeout(sessionId)];
            case 1:
              configAPIResponse = _a.sent();
              if (configAPIResponse) {
                remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                if (remoteConfig) {
                  this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                  return [2 /*return*/, remoteConfig];
                }
              }
              this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    this.getRemoteConfig = function (configNamespace, key, sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var namespaceConfig;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, this.getRemoteNamespaceConfig(configNamespace, sessionId)];
            case 1:
              namespaceConfig = _a.sent();
              return [2 /*return*/, namespaceConfig === null || namespaceConfig === void 0 ? void 0 : namespaceConfig[key]];
          }
        });
      });
    };
    this.fetchWithTimeout = function (sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var controller, timeoutId, remoteConfig;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              controller = new AbortController();
              timeoutId = setTimeout(function () {
                return controller.abort();
              }, 5000);
              return [4 /*yield*/, this.fetchRemoteConfig(controller.signal, sessionId)];
            case 1:
              remoteConfig = _a.sent();
              clearTimeout(timeoutId);
              return [2 /*return*/, remoteConfig];
          }
        });
      });
    };
    this.fetchRemoteConfig = function (signal, sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var urlParams, _a, _b, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
        var e_2, _c;
        var _d;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) {
                return [2 /*return*/, this.completeRequest({
                  err: MAX_RETRIES_EXCEEDED_MESSAGE$1
                })];
              } else if (signal.aborted) {
                return [2 /*return*/, this.completeRequest({
                  err: TIMEOUT_MESSAGE
                })];
              } else if (sessionId !== this.lastFetchedSessionId) {
                this.lastFetchedSessionId = sessionId;
                this.attempts = 0;
              }
              _e.label = 1;
            case 1:
              _e.trys.push([1, 3,, 4]);
              urlParams = new URLSearchParams({
                api_key: this.localConfig.apiKey
              });
              try {
                for (_a = __values$1(this.configKeys), _b = _a.next(); !_b.done; _b = _a.next()) {
                  configKey = _b.value;
                  urlParams.append('config_keys', configKey);
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }
              if (sessionId) {
                urlParams.set('session_id', String(sessionId));
              }
              options = {
                headers: {
                  Accept: '*/*'
                },
                method: 'GET'
              };
              serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
              this.attempts += 1;
              return [4 /*yield*/, fetch(serverUrl, _assign$(_assign$({}, options), {
                signal: signal
              }))];
            case 2:
              res = _e.sent();
              if (res === null) {
                return [2 /*return*/, this.completeRequest({
                  err: UNEXPECTED_ERROR_MESSAGE$1
                })];
              }
              parsedStatus = new BaseTransport().buildStatus(res.status);
              switch (parsedStatus) {
                case Status.Success:
                  this.attempts = 0;
                  return [2 /*return*/, this.parseAndStoreConfig(res)];
                case Status.Failed:
                  return [2 /*return*/, this.retryFetch(signal, sessionId)];
                default:
                  return [2 /*return*/, this.completeRequest({
                    err: UNEXPECTED_NETWORK_ERROR_MESSAGE$1
                  })];
              }
            case 3:
              e_1 = _e.sent();
              knownError = e_1;
              if (signal.aborted) {
                return [2 /*return*/, this.completeRequest({
                  err: TIMEOUT_MESSAGE
                })];
              }
              return [2 /*return*/, this.completeRequest({
                err: (_d = knownError.message) !== null && _d !== void 0 ? _d : UNEXPECTED_ERROR_MESSAGE$1
              })];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    this.retryFetch = function (signal, sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, new Promise(function (resolve) {
                return setTimeout(resolve, _this.attempts * _this.retryTimeout);
              })];
            case 1:
              _a.sent();
              return [2 /*return*/, this.fetchRemoteConfig(signal, sessionId)];
          }
        });
      });
    };
    this.parseAndStoreConfig = function (res) {
      return __awaiter(_this, void 0, void 0, function () {
        var remoteConfig;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, res.json()];
            case 1:
              remoteConfig = _a.sent();
              this.completeRequest({
                success: SUCCESS_REMOTE_CONFIG
              });
              return [2 /*return*/, remoteConfig];
          }
        });
      });
    };
    this.localConfig = localConfig;
    this.configKeys = configKeys;
  }
  RemoteConfigFetch.prototype.getServerUrl = function () {
    if (this.localConfig.configServerUrl) {
      return this.localConfig.configServerUrl;
    }
    if (this.localConfig.serverZone === ServerZone.STAGING) {
      return REMOTE_CONFIG_SERVER_URL_STAGING;
    }
    if (this.localConfig.serverZone === ServerZone.EU) {
      return REMOTE_CONFIG_SERVER_URL_EU;
    }
    return REMOTE_CONFIG_SERVER_URL;
  };
  RemoteConfigFetch.prototype.completeRequest = function (_a) {
    var err = _a.err,
      success = _a.success;
    if (err) {
      throw new Error(err);
    } else if (success) {
      this.localConfig.loggerProvider.log(success);
    }
  };
  return RemoteConfigFetch;
}();
var createRemoteConfigFetch$1 = function createRemoteConfigFetch$1(_a) {
  var localConfig = _a.localConfig,
    configKeys = _a.configKeys;
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2 /*return*/, new RemoteConfigFetch({
        localConfig: localConfig,
        configKeys: configKeys
      })];
    });
  });
};
var createRemoteConfigFetch = createRemoteConfigFetch$1;
var removeInvalidSelectorsFromPrivacyConfig = function removeInvalidSelectorsFromPrivacyConfig(privacyConfig, loggerProvider) {
  // This allows us to not search the DOM.
  var fragment = document.createDocumentFragment();
  var dropInvalidSelectors = function dropInvalidSelectors(selectors) {
    if (selectors === void 0) {
      selectors = [];
    }
    if (typeof selectors === 'string') {
      selectors = [selectors];
    }
    selectors = selectors.filter(function (selector) {
      try {
        fragment.querySelector(selector);
      } catch (_a) {
        loggerProvider.warn("[session-replay-browser] omitting selector \"".concat(selector, "\" because it is invalid"));
        return false;
      }
      return true;
    });
    if (selectors.length === 0) {
      return undefined;
    }
    return selectors;
  };
  privacyConfig.blockSelector = dropInvalidSelectors(privacyConfig.blockSelector);
  privacyConfig.maskSelector = dropInvalidSelectors(privacyConfig.maskSelector);
  privacyConfig.unmaskSelector = dropInvalidSelectors(privacyConfig.unmaskSelector);
  return privacyConfig;
};
var SessionReplayJoinedConfigGenerator = /** @class */function () {
  function SessionReplayJoinedConfigGenerator(remoteConfigFetch, localConfig) {
    this.localConfig = localConfig;
    this.remoteConfigFetch = remoteConfigFetch;
  }
  SessionReplayJoinedConfigGenerator.prototype.generateJoinedConfig = function (sessionId) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
      var config, remoteConfig, namespaceConfig, samplingConfig_1, privacyConfig, ugcFilterRules, err_1, knownError, samplingConfig, remotePrivacyConfig, localPrivacyConfig, joinedPrivacyConfig, privacyConfigSelectorMap, selectorMap, _e, _f, _g, selector, selectorType;
      var e_1, _h;
      return __generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            config = _assign$({}, this.localConfig);
            // Special case here as optOut is implemented via getter/setter
            config.optOut = this.localConfig.optOut;
            // We always want captureEnabled to be true, unless there's an override
            // in the remote config.
            config.captureEnabled = true;
            _j.label = 1;
          case 1:
            _j.trys.push([1, 3,, 4]);
            return [4 /*yield*/, this.remoteConfigFetch.getRemoteNamespaceConfig('sessionReplay', sessionId)];
          case 2:
            namespaceConfig = _j.sent();
            if (namespaceConfig) {
              samplingConfig_1 = namespaceConfig.sr_sampling_config;
              privacyConfig = namespaceConfig.sr_privacy_config;
              ugcFilterRules = (_a = config.interactionConfig) === null || _a === void 0 ? void 0 : _a.ugcFilterRules;
              // This is intentionally forced to only be set through the remote config.
              config.interactionConfig = namespaceConfig.sr_interaction_config;
              if (config.interactionConfig && ugcFilterRules) {
                config.interactionConfig.ugcFilterRules = ugcFilterRules;
              }
              // This is intentionally forced to only be set through the remote config.
              config.loggingConfig = namespaceConfig.sr_logging_config;
              if (samplingConfig_1 || privacyConfig) {
                remoteConfig = {};
                if (samplingConfig_1) {
                  remoteConfig.sr_sampling_config = samplingConfig_1;
                }
                if (privacyConfig) {
                  remoteConfig.sr_privacy_config = privacyConfig;
                }
              }
            }
            return [3 /*break*/, 4];
          case 3:
            err_1 = _j.sent();
            knownError = err_1;
            this.localConfig.loggerProvider.warn(knownError.message);
            config.captureEnabled = false;
            return [3 /*break*/, 4];
          case 4:
            if (!remoteConfig) {
              return [2 /*return*/, {
                localConfig: this.localConfig,
                joinedConfig: config,
                remoteConfig: remoteConfig
              }];
            }
            samplingConfig = remoteConfig.sr_sampling_config, remotePrivacyConfig = remoteConfig.sr_privacy_config;
            if (samplingConfig && Object.keys(samplingConfig).length > 0) {
              if (Object.prototype.hasOwnProperty.call(samplingConfig, 'capture_enabled')) {
                config.captureEnabled = samplingConfig.capture_enabled;
              } else {
                config.captureEnabled = false;
              }
              if (Object.prototype.hasOwnProperty.call(samplingConfig, 'sample_rate')) {
                config.sampleRate = samplingConfig.sample_rate;
              }
            } else {
              // If config API response was valid (ie 200), but no config returned, assume that
              // customer has not yet set up config, and use sample rate from SDK options,
              // allowing for immediate replay capture
              config.captureEnabled = true;
              this.localConfig.loggerProvider.debug('Remote config successfully fetched, but no values set for project, Session Replay capture enabled.');
            }
            // Remote config join acts somewhat like a left join between the remote and the local
            // config. That is, remote config has precedence over local values as with sampling.
            // However, non conflicting values will be added to the lists.
            // Here's an example to illustrate:
            //
            // Remote config:   {'.selector1': 'MASK',   '.selector2': 'UNMASK'}
            // Local config:    {'.selector1': 'UNMASK',                         '.selector3': 'MASK'}
            //
            // Resolved config: {'.selector1': 'MASK',   '.selector2': 'UNMASK', '.selector3': 'MASK'}
            // config.privacyConfig = {
            //   ...(config.privacyConfig ?? {}),
            //   ...remotePrivacyConfig,
            // };
            if (remotePrivacyConfig) {
              localPrivacyConfig = (_b = config.privacyConfig) !== null && _b !== void 0 ? _b : {};
              joinedPrivacyConfig = {
                defaultMaskLevel: (_d = (_c = remotePrivacyConfig.defaultMaskLevel) !== null && _c !== void 0 ? _c : localPrivacyConfig.defaultMaskLevel) !== null && _d !== void 0 ? _d : 'medium',
                blockSelector: [],
                maskSelector: [],
                unmaskSelector: []
              };
              privacyConfigSelectorMap = function (privacyConfig) {
                var e_2, _a, e_3, _b, e_4, _c;
                var _d, _e, _f;
                var selectorMap = {};
                if (typeof privacyConfig.blockSelector === 'string') {
                  privacyConfig.blockSelector = [privacyConfig.blockSelector];
                }
                try {
                  for (var _g = __values$1((_d = privacyConfig.blockSelector) !== null && _d !== void 0 ? _d : []), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var selector = _h.value;
                    selectorMap[selector] = 'block';
                  }
                } catch (e_2_1) {
                  e_2 = {
                    error: e_2_1
                  };
                } finally {
                  try {
                    if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                  } finally {
                    if (e_2) throw e_2.error;
                  }
                }
                try {
                  for (var _j = __values$1((_e = privacyConfig.maskSelector) !== null && _e !== void 0 ? _e : []), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var selector = _k.value;
                    selectorMap[selector] = 'mask';
                  }
                } catch (e_3_1) {
                  e_3 = {
                    error: e_3_1
                  };
                } finally {
                  try {
                    if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                  } finally {
                    if (e_3) throw e_3.error;
                  }
                }
                try {
                  for (var _l = __values$1((_f = privacyConfig.unmaskSelector) !== null && _f !== void 0 ? _f : []), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var selector = _m.value;
                    selectorMap[selector] = 'unmask';
                  }
                } catch (e_4_1) {
                  e_4 = {
                    error: e_4_1
                  };
                } finally {
                  try {
                    if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
                  } finally {
                    if (e_4) throw e_4.error;
                  }
                }
                return selectorMap;
              };
              selectorMap = _assign$(_assign$({}, privacyConfigSelectorMap(localPrivacyConfig)), privacyConfigSelectorMap(remotePrivacyConfig));
              try {
                for (_e = __values$1(Object.entries(selectorMap)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  _g = __read$1(_f.value, 2), selector = _g[0], selectorType = _g[1];
                  if (selectorType === 'mask') {
                    joinedPrivacyConfig.maskSelector.push(selector);
                  } else if (selectorType === 'block') {
                    joinedPrivacyConfig.blockSelector.push(selector);
                  } else if (selectorType === 'unmask') {
                    joinedPrivacyConfig.unmaskSelector.push(selector);
                  }
                }
              } catch (e_1_1) {
                e_1 = {
                  error: e_1_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }
              config.privacyConfig = removeInvalidSelectorsFromPrivacyConfig(joinedPrivacyConfig, this.localConfig.loggerProvider);
            }
            this.localConfig.loggerProvider.debug(JSON.stringify({
              name: 'session replay joined config',
              config: getDebugConfig(config)
            }, null, 2));
            return [2 /*return*/, {
              localConfig: this.localConfig,
              joinedConfig: config,
              remoteConfig: remoteConfig
            }];
        }
      });
    });
  };
  return SessionReplayJoinedConfigGenerator;
}();
var createSessionReplayJoinedConfigGenerator = function createSessionReplayJoinedConfigGenerator(apiKey, options) {
  return __awaiter(void 0, void 0, void 0, function () {
    var localConfig, remoteConfigFetch;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          localConfig = new SessionReplayLocalConfig(apiKey, options);
          return [4 /*yield*/, createRemoteConfigFetch({
            localConfig: localConfig,
            configKeys: ['sessionReplay']
          })];
        case 1:
          remoteConfigFetch = _a.sent();
          return [2 /*return*/, new SessionReplayJoinedConfigGenerator(remoteConfigFetch, localConfig)];
      }
    });
  });
};
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, event batch rejected';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Session replay event batch rejected due to exceeded retry count';
var STORAGE_FAILURE = 'Failed to store session replay events in IndexedDB';
var MISSING_DEVICE_ID_MESSAGE = 'Session replay event batch not sent due to missing device ID';
var MISSING_API_KEY_MESSAGE = 'Session replay event batch not sent due to missing api key';

// Autogenerated by `yarn version-file`. DO NOT EDIT
var VERSION = '1.27.0';
var SessionReplayTrackDestination = /** @class */function () {
  function SessionReplayTrackDestination(_a) {
    var trackServerUrl = _a.trackServerUrl,
      loggerProvider = _a.loggerProvider,
      payloadBatcher = _a.payloadBatcher;
    this.storageKey = '';
    this.retryTimeout = 1000;
    this.scheduled = null;
    this.queue = [];
    this.loggerProvider = loggerProvider;
    this.payloadBatcher = payloadBatcher ? payloadBatcher : function (payload) {
      return payload;
    };
    this.trackServerUrl = trackServerUrl;
  }
  SessionReplayTrackDestination.prototype.sendEventsList = function (destinationData) {
    this.addToQueue(_assign$(_assign$({}, destinationData), {
      attempts: 0,
      timeout: 0
    }));
  };
  SessionReplayTrackDestination.prototype.addToQueue = function () {
    var _this = this;
    var list = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      list[_i] = arguments[_i];
    }
    var tryable = list.filter(function (context) {
      if (context.attempts < (context.flushMaxRetries || 0)) {
        context.attempts += 1;
        return true;
      }
      _this.completeRequest({
        context: context,
        err: MAX_RETRIES_EXCEEDED_MESSAGE
      });
      return false;
    });
    tryable.forEach(function (context) {
      _this.queue = _this.queue.concat(context);
      if (context.timeout === 0) {
        _this.schedule(0);
        return;
      }
      setTimeout(function () {
        context.timeout = 0;
        _this.schedule(0);
      }, context.timeout);
    });
  };
  SessionReplayTrackDestination.prototype.schedule = function (timeout) {
    var _this = this;
    if (this.scheduled) return;
    this.scheduled = setTimeout(function () {
      void _this.flush(true).then(function () {
        if (_this.queue.length > 0) {
          _this.schedule(timeout);
        }
      });
    }, timeout);
  };
  SessionReplayTrackDestination.prototype.flush = function (useRetry) {
    if (useRetry === void 0) {
      useRetry = false;
    }
    return __awaiter(this, void 0, void 0, function () {
      var list, later;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            list = [];
            later = [];
            this.queue.forEach(function (context) {
              return context.timeout === 0 ? list.push(context) : later.push(context);
            });
            this.queue = later;
            if (this.scheduled) {
              clearTimeout(this.scheduled);
              this.scheduled = null;
            }
            return [4 /*yield*/, Promise.all(list.map(function (context) {
              return _this.send(context, useRetry);
            }))];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.send = function (context, useRetry) {
    var _a, _b;
    if (useRetry === void 0) {
      useRetry = true;
    }
    return __awaiter(this, void 0, void 0, function () {
      var apiKey, deviceId, url, version, sampleRate, urlParams, sessionReplayLibrary, payload, options, serverUrl, res, responseBody, e_1;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            apiKey = context.apiKey;
            if (!apiKey) {
              return [2 /*return*/, this.completeRequest({
                context: context,
                err: MISSING_API_KEY_MESSAGE
              })];
            }
            deviceId = context.deviceId;
            if (!deviceId) {
              return [2 /*return*/, this.completeRequest({
                context: context,
                err: MISSING_DEVICE_ID_MESSAGE
              })];
            }
            url = getCurrentUrl();
            version = VERSION;
            sampleRate = context.sampleRate;
            urlParams = new URLSearchParams({
              device_id: deviceId,
              session_id: "".concat(context.sessionId),
              type: "".concat(context.type)
            });
            sessionReplayLibrary = "".concat(((_a = context.version) === null || _a === void 0 ? void 0 : _a.type) || 'standalone', "/").concat(((_b = context.version) === null || _b === void 0 ? void 0 : _b.version) || version);
            payload = this.payloadBatcher({
              version: 1,
              events: context.events
            });
            if (payload.events.length === 0) {
              this.completeRequest({
                context: context
              });
              return [2 /*return*/];
            }
            _c.label = 1;
          case 1:
            _c.trys.push([1, 3,, 4]);
            options = {
              headers: {
                'Content-Type': 'application/json',
                Accept: '*/*',
                Authorization: "Bearer ".concat(apiKey),
                'X-Client-Version': version,
                'X-Client-Library': sessionReplayLibrary,
                'X-Client-Url': url.substring(0, MAX_URL_LENGTH),
                'X-Client-Sample-Rate': "".concat(sampleRate)
              },
              body: JSON.stringify(payload),
              method: 'POST'
            };
            serverUrl = "".concat(getServerUrl(context.serverZone, this.trackServerUrl), "?").concat(urlParams.toString());
            return [4 /*yield*/, fetch(serverUrl, options)];
          case 2:
            res = _c.sent();
            if (res === null) {
              this.completeRequest({
                context: context,
                err: UNEXPECTED_ERROR_MESSAGE
              });
              return [2 /*return*/];
            }
            if (!useRetry) {
              responseBody = '';
              try {
                responseBody = JSON.stringify(res.body, null, 2);
              } catch (_d) {
                // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
              }
              this.completeRequest({
                context: context,
                success: "".concat(res.status, ": ").concat(responseBody)
              });
            } else {
              this.handleReponse(res.status, context);
            }
            return [3 /*break*/, 4];
          case 3:
            e_1 = _c.sent();
            this.completeRequest({
              context: context,
              err: e_1
            });
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayTrackDestination.prototype.handleReponse = function (status, context) {
    var parsedStatus = new BaseTransport$1().buildStatus(status);
    switch (parsedStatus) {
      case Status$1.Success:
        this.handleSuccessResponse(context);
        break;
      case Status$1.Failed:
        this.handleOtherResponse(context);
        break;
      default:
        this.completeRequest({
          context: context,
          err: UNEXPECTED_NETWORK_ERROR_MESSAGE
        });
    }
  };
  SessionReplayTrackDestination.prototype.handleSuccessResponse = function (context) {
    var sizeOfEventsList = Math.round(new Blob(context.events).size / KB_SIZE);
    this.completeRequest({
      context: context,
      success: "Session replay event batch tracked successfully for session id ".concat(context.sessionId, ", size of events: ").concat(sizeOfEventsList, " KB")
    });
  };
  SessionReplayTrackDestination.prototype.handleOtherResponse = function (context) {
    this.addToQueue(_assign$(_assign$({}, context), {
      timeout: context.attempts * this.retryTimeout
    }));
  };
  SessionReplayTrackDestination.prototype.completeRequest = function (_a) {
    var context = _a.context,
      err = _a.err,
      success = _a.success;
    void context.onComplete();
    if (err) {
      this.loggerProvider.warn(err);
    } else if (success) {
      this.loggerProvider.log(success);
    }
  };
  return SessionReplayTrackDestination;
}();
const instanceOfAny = (object, constructors) => constructors.some(c => object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey]);
}
const transactionDoneMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
  const promise = new Promise((resolve, reject) => {
    const unlisten = () => {
      request.removeEventListener('success', success);
      request.removeEventListener('error', error);
    };
    const success = () => {
      resolve(wrap(request.result));
      unlisten();
    };
    const error = () => {
      reject(request.error);
      unlisten();
    };
    request.addEventListener('success', success);
    request.addEventListener('error', error);
  });
  // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
  // is because we create many promises from a single IDBRequest.
  reverseTransformCache.set(promise, request);
  return promise;
}
function cacheDonePromiseForTransaction(tx) {
  // Early bail if we've already created a done promise for this transaction.
  if (transactionDoneMap.has(tx)) return;
  const done = new Promise((resolve, reject) => {
    const unlisten = () => {
      tx.removeEventListener('complete', complete);
      tx.removeEventListener('error', error);
      tx.removeEventListener('abort', error);
    };
    const complete = () => {
      resolve();
      unlisten();
    };
    const error = () => {
      reject(tx.error || new DOMException('AbortError', 'AbortError'));
      unlisten();
    };
    tx.addEventListener('complete', complete);
    tx.addEventListener('error', error);
    tx.addEventListener('abort', error);
  });
  // Cache it for later retrieval.
  transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
  get(target, prop, receiver) {
    if (target instanceof IDBTransaction) {
      // Special handling for transaction.done.
      if (prop === 'done') return transactionDoneMap.get(target);
      // Make tx.store return the only store in the transaction, or undefined if there are many.
      if (prop === 'store') {
        return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    }
    // Else transform whatever we get back.
    return wrap(target[prop]);
  },
  set(target, prop, value) {
    target[prop] = value;
    return true;
  },
  has(target, prop) {
    if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) {
      return true;
    }
    return prop in target;
  }
};
function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
  // Due to expected object equality (which is enforced by the caching in `wrap`), we
  // only create one new func per func.
  // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
  // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
  // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
  // with real promises, so each advance methods returns a new promise for the cursor object, or
  // undefined if the end of the cursor has been reached.
  if (getCursorAdvanceMethods().includes(func)) {
    return function (...args) {
      // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
      // the original object.
      func.apply(unwrap(this), args);
      return wrap(this.request);
    };
  }
  return function (...args) {
    // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
    // the original object.
    return wrap(func.apply(unwrap(this), args));
  };
}
function transformCachableValue(value) {
  if (typeof value === 'function') return wrapFunction(value);
  // This doesn't return, it just creates a 'done' promise for the transaction,
  // which is later returned for transaction.done (see idbObjectHandler).
  if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
  // Return the same value back if we're not going to transform it.
  return value;
}
function wrap(value) {
  // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
  // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
  if (value instanceof IDBRequest) return promisifyRequest(value);
  // If we've already transformed this value before, reuse the transformed value.
  // This is faster, but it also provides object equality.
  if (transformCache.has(value)) return transformCache.get(value);
  const newValue = transformCachableValue(value);
  // Not all types are transformed.
  // These may be primitive types, so they can't be WeakMap keys.
  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }
  return newValue;
}
const unwrap = value => reverseTransformCache.get(value);

/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, {
  blocked,
  upgrade,
  blocking,
  terminated
} = {}) {
  const request = indexedDB.open(name, version);
  const openPromise = wrap(request);
  if (upgrade) {
    request.addEventListener('upgradeneeded', event => {
      upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
    });
  }
  if (blocked) {
    request.addEventListener('blocked', event => blocked(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    event.oldVersion, event.newVersion, event));
  }
  openPromise.then(db => {
    if (terminated) db.addEventListener('close', () => terminated());
    if (blocking) {
      db.addEventListener('versionchange', event => blocking(event.oldVersion, event.newVersion, event));
    }
  }).catch(() => {});
  return openPromise;
}
const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
  if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) {
    return;
  }
  if (cachedMethods.get(prop)) return cachedMethods.get(prop);
  const targetFuncName = prop.replace(/FromIndex$/, '');
  const useIndex = prop !== targetFuncName;
  const isWrite = writeMethods.includes(targetFuncName);
  if (
  // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
  !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) {
    return;
  }
  const method = async function method(storeName, ...args) {
    // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
    const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
    let target = tx.store;
    if (useIndex) target = target.index(args.shift());
    // Must reject if op rejects.
    // If it's a write operation, must reject if tx.done rejects.
    // Must reject with op rejection first.
    // Must resolve with op value.
    // Must handle both promises (no unhandled rejections)
    return (await Promise.all([target[targetFuncName](...args), isWrite && tx.done]))[0];
  };
  cachedMethods.set(prop, method);
  return method;
}
replaceTraps(oldTraps => Object.assign({}, oldTraps, {
  get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
  has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop)
}));
const advanceMethodProps = ['continue', 'continuePrimaryKey', 'advance'];
const methodMap = {};
const advanceResults = new WeakMap();
const ittrProxiedCursorToOriginalProxy = new WeakMap();
const cursorIteratorTraps = {
  get(target, prop) {
    if (!advanceMethodProps.includes(prop)) return target[prop];
    let cachedFunc = methodMap[prop];
    if (!cachedFunc) {
      cachedFunc = methodMap[prop] = function (...args) {
        advanceResults.set(this, ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
      };
    }
    return cachedFunc;
  }
};
async function* iterate(...args) {
  // tslint:disable-next-line:no-this-assignment
  let cursor = this;
  if (!(cursor instanceof IDBCursor)) {
    cursor = await cursor.openCursor(...args);
  }
  if (!cursor) return;
  cursor = cursor;
  const proxiedCursor = new Proxy(cursor, cursorIteratorTraps);
  ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
  // Map this double-proxy back to the original, so other cursor methods work.
  reverseTransformCache.set(proxiedCursor, unwrap(cursor));
  while (cursor) {
    yield proxiedCursor;
    // If one of the advancing methods was not called, call continue().
    cursor = await (advanceResults.get(proxiedCursor) || cursor.continue());
    advanceResults.delete(proxiedCursor);
  }
}
function isIteratorProp(target, prop) {
  return prop === Symbol.asyncIterator && instanceOfAny(target, [IDBIndex, IDBObjectStore, IDBCursor]) || prop === 'iterate' && instanceOfAny(target, [IDBIndex, IDBObjectStore]);
}
replaceTraps(oldTraps => Object.assign({}, oldTraps, {
  get(target, prop, receiver) {
    if (isIteratorProp(target, prop)) return iterate;
    return oldTraps.get(target, prop, receiver);
  },
  has(target, prop) {
    return isIteratorProp(target, prop) || oldTraps.has(target, prop);
  }
}));
var BaseEventsStore = /** @class */function () {
  function BaseEventsStore(args) {
    var _this = this;
    var _a, _b, _c;
    this.minInterval = MIN_INTERVAL;
    this.maxInterval = MAX_INTERVAL;
    this.maxPersistedEventsSize = MAX_EVENT_LIST_SIZE;
    this.interval = this.minInterval;
    this._timeAtLastSplit = Date.now(); // Initialize this so we have a point of comparison when events are recorded
    /**
     * Determines whether to send the events list to the backend and start a new
     * empty events list, based on the size of the list as well as the last time sent
     * @param nextEventString
     * @returns boolean
     */
    this.shouldSplitEventsList = function (events, nextEventString) {
      var sizeOfNextEvent = _this.getStringSize(nextEventString);
      var sizeOfEventsList = _this.getEventsArraySize(events);
      // Check size constraint first (most likely to trigger)
      if (sizeOfEventsList + sizeOfNextEvent >= _this.maxPersistedEventsSize) {
        return true;
      }
      if (Date.now() - _this.timeAtLastSplit > _this.interval && events.length) {
        _this.interval = Math.min(_this.maxInterval, _this.interval + _this.minInterval);
        _this._timeAtLastSplit = Date.now();
        return true;
      }
      return false;
    };
    this.loggerProvider = args.loggerProvider;
    this.minInterval = (_a = args.minInterval) !== null && _a !== void 0 ? _a : this.minInterval;
    this.maxInterval = (_b = args.maxInterval) !== null && _b !== void 0 ? _b : this.maxInterval;
    this.maxPersistedEventsSize = (_c = args.maxPersistedEventsSize) !== null && _c !== void 0 ? _c : this.maxPersistedEventsSize;
  }
  Object.defineProperty(BaseEventsStore.prototype, "timeAtLastSplit", {
    get: function () {
      return this._timeAtLastSplit;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Calculates the character length of a string as size approximation
   * Note: String length closely approximates byte size for most content
   */
  BaseEventsStore.prototype.getStringSize = function (str) {
    return str.length;
  };
  /**
   * Calculates the total character length of events array
   * Accounts for JSON serialization overhead when sent to backend
   */
  BaseEventsStore.prototype.getEventsArraySize = function (events) {
    var e_1, _a;
    var totalSize = 0;
    try {
      for (var events_1 = __values$1(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
        var event_1 = events_1_1.value;
        totalSize += this.getStringSize(event_1);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    // Additional overhead from using length instead of byte size
    // - Array brackets: [] = 2 characters
    // - Commas between events: events.length - 1
    // - Double quotes around each event: events.length * 2
    var overhead = 2 + Math.max(0, events.length - 1) + events.length * 2;
    return totalSize + overhead;
  };
  return BaseEventsStore;
}();
var RecordingStatus;
(function (RecordingStatus) {
  RecordingStatus["RECORDING"] = "recording";
  RecordingStatus["SENT"] = "sent";
})(RecordingStatus || (RecordingStatus = {}));
var currentSequenceKey = 'sessionCurrentSequence';
var sequencesToSendKey = 'sequencesToSend';
var keyValDatabaseExists = function keyValDatabaseExists() {
  var globalScope = getGlobalScope();
  return new Promise(function (resolve, reject) {
    if (!globalScope) {
      return reject(new Error('Global scope not found'));
    }
    if (!globalScope.indexedDB) {
      return reject(new Error('Session Replay: cannot find indexedDB'));
    }
    try {
      var request_1 = globalScope.indexedDB.open('keyval-store');
      request_1.onupgradeneeded = function () {
        if (request_1.result.version === 1) {
          request_1.result.close();
          request_1.transaction && request_1.transaction.abort();
          globalScope.indexedDB.deleteDatabase('keyval-store');
          resolve();
        }
      };
      request_1.onsuccess = function () {
        resolve(request_1.result);
      };
      request_1.onerror = function () {
        reject(request_1.error);
      };
    } catch (e) {
      reject(e);
    }
  });
};
var batchPromiseAll = function batchPromiseAll(promiseBatch) {
  return __awaiter(void 0, void 0, void 0, function () {
    var chunkSize, batch;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!(promiseBatch.length > 0)) return [3 /*break*/, 2];
          chunkSize = 10;
          batch = promiseBatch.splice(0, chunkSize);
          return [4 /*yield*/, Promise.all(batch)];
        case 1:
          _a.sent();
          return [3 /*break*/, 0];
        case 2:
          return [2 /*return*/];
      }
    });
  });
};
var defineObjectStores = function defineObjectStores(db) {
  var sequencesStore;
  var currentSequenceStore;
  if (!db.objectStoreNames.contains(currentSequenceKey)) {
    currentSequenceStore = db.createObjectStore(currentSequenceKey, {
      keyPath: 'sessionId'
    });
  }
  if (!db.objectStoreNames.contains(sequencesToSendKey)) {
    sequencesStore = db.createObjectStore(sequencesToSendKey, {
      keyPath: 'sequenceId',
      autoIncrement: true
    });
    sequencesStore.createIndex('sessionId', 'sessionId');
  }
  return {
    sequencesStore: sequencesStore,
    currentSequenceStore: currentSequenceStore
  };
};
var createStore = function createStore(dbName) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, openDB(dbName, 1, {
            upgrade: defineObjectStores
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var SessionReplayEventsIDBStore = /** @class */function (_super) {
  __extends(SessionReplayEventsIDBStore, _super);
  function SessionReplayEventsIDBStore(args) {
    var _this = _super.call(this, args) || this;
    _this.getSequencesToSend = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var sequences, cursor, _a, sessionId, events, e_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 5,, 6]);
              sequences = [];
              return [4 /*yield*/, this.db.transaction('sequencesToSend').store.openCursor()];
            case 1:
              cursor = _b.sent();
              _b.label = 2;
            case 2:
              if (!cursor) return [3 /*break*/, 4];
              _a = cursor.value, sessionId = _a.sessionId, events = _a.events;
              sequences.push({
                events: events,
                sequenceId: cursor.key,
                sessionId: sessionId
              });
              return [4 /*yield*/, cursor.continue()];
            case 3:
              cursor = _b.sent();
              return [3 /*break*/, 2];
            case 4:
              return [2 /*return*/, sequences];
            case 5:
              e_1 = _b.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_1));
              return [3 /*break*/, 6];
            case 6:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.storeCurrentSequence = function (sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var currentSequenceData, sequenceId, e_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 4,, 5]);
              return [4 /*yield*/, this.db.get(currentSequenceKey, sessionId)];
            case 1:
              currentSequenceData = _a.sent();
              if (!currentSequenceData) {
                return [2 /*return*/, undefined];
              }
              return [4 /*yield*/, this.db.put(sequencesToSendKey, {
                sessionId: sessionId,
                events: currentSequenceData.events
              })];
            case 2:
              sequenceId = _a.sent();
              return [4 /*yield*/, this.db.put(currentSequenceKey, {
                sessionId: sessionId,
                events: []
              })];
            case 3:
              _a.sent();
              return [2 /*return*/, _assign$(_assign$({}, currentSequenceData), {
                sessionId: sessionId,
                sequenceId: sequenceId
              })];
            case 4:
              e_2 = _a.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_2));
              return [3 /*break*/, 5];
            case 5:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.addEventToCurrentSequence = function (sessionId, event) {
      return __awaiter(_this, void 0, void 0, function () {
        var tx, sequenceEvents, eventsToSend, updatedEvents, sequenceId, e_3;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 10,, 11]);
              tx = this.db.transaction(currentSequenceKey, 'readwrite');
              return [4 /*yield*/, tx.store.get(sessionId)];
            case 1:
              sequenceEvents = _a.sent();
              if (!!sequenceEvents) return [3 /*break*/, 3];
              return [4 /*yield*/, tx.store.put({
                sessionId: sessionId,
                events: [event]
              })];
            case 2:
              _a.sent();
              return [2 /*return*/];
            case 3:
              eventsToSend = void 0;
              if (!this.shouldSplitEventsList(sequenceEvents.events, event)) return [3 /*break*/, 5];
              eventsToSend = sequenceEvents.events;
              // set store to empty array
              return [4 /*yield*/, tx.store.put({
                sessionId: sessionId,
                events: [event]
              })];
            case 4:
              // set store to empty array
              _a.sent();
              return [3 /*break*/, 7];
            case 5:
              updatedEvents = sequenceEvents.events.concat(event);
              return [4 /*yield*/, tx.store.put({
                sessionId: sessionId,
                events: updatedEvents
              })];
            case 6:
              _a.sent();
              _a.label = 7;
            case 7:
              return [4 /*yield*/, tx.done];
            case 8:
              _a.sent();
              if (!eventsToSend) {
                return [2 /*return*/, undefined];
              }
              return [4 /*yield*/, this.storeSendingEvents(sessionId, eventsToSend)];
            case 9:
              sequenceId = _a.sent();
              if (!sequenceId) {
                return [2 /*return*/, undefined];
              }
              return [2 /*return*/, {
                events: eventsToSend,
                sessionId: sessionId,
                sequenceId: sequenceId
              }];
            case 10:
              e_3 = _a.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_3));
              return [3 /*break*/, 11];
            case 11:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.storeSendingEvents = function (sessionId, events) {
      return __awaiter(_this, void 0, void 0, function () {
        var sequenceId, e_4;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);
              return [4 /*yield*/, this.db.put(sequencesToSendKey, {
                sessionId: sessionId,
                events: events
              })];
            case 1:
              sequenceId = _a.sent();
              return [2 /*return*/, sequenceId];
            case 2:
              e_4 = _a.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_4));
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/, undefined];
          }
        });
      });
    };
    _this.cleanUpSessionEventsStore = function (_sessionId, sequenceId) {
      return __awaiter(_this, void 0, void 0, function () {
        var e_5;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!sequenceId) {
                return [2 /*return*/];
              }
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4 /*yield*/, this.db.delete(sequencesToSendKey, sequenceId)];
            case 2:
              _a.sent();
              return [3 /*break*/, 4];
            case 3:
              e_5 = _a.sent();
              this.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_5));
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    _this.transitionFromKeyValStore = function (sessionId) {
      return __awaiter(_this, void 0, void 0, function () {
        var keyValDb, transitionCurrentSessionSequences_1, storageKey, getAllRequest_1, transitionPromise, globalScope, e_6, e_7;
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 6,, 7]);
              return [4 /*yield*/, keyValDatabaseExists()];
            case 1:
              keyValDb = _a.sent();
              if (!keyValDb) {
                return [2 /*return*/];
              }
              transitionCurrentSessionSequences_1 = function (numericSessionId, sessionStore) {
                return __awaiter(_this, void 0, void 0, function () {
                  var currentSessionSequences, promisesToBatch;
                  var _this = this;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        currentSessionSequences = sessionStore.sessionSequences;
                        promisesToBatch = [];
                        Object.keys(currentSessionSequences).forEach(function (sequenceId) {
                          var numericSequenceId = parseInt(sequenceId, 10);
                          var sequence = currentSessionSequences[numericSequenceId];
                          if (numericSequenceId === sessionStore.currentSequenceId) {
                            var eventAddPromises = sequence.events.map(function (event) {
                              return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                  return [2 /*return*/, this.addEventToCurrentSequence(numericSessionId, event)];
                                });
                              });
                            });
                            promisesToBatch.push.apply(promisesToBatch, __spreadArray([], __read$1(eventAddPromises), false));
                          } else if (sequence.status !== RecordingStatus.SENT) {
                            promisesToBatch.push(_this.storeSendingEvents(numericSessionId, sequence.events));
                          }
                        });
                        return [4 /*yield*/, batchPromiseAll(promisesToBatch)];
                      case 1:
                        _a.sent();
                        return [2 /*return*/];
                    }
                  });
                });
              };
              storageKey = "".concat(STORAGE_PREFIX, "_").concat(this.apiKey.substring(0, 10));
              _a.label = 2;
            case 2:
              _a.trys.push([2, 4,, 5]);
              getAllRequest_1 = keyValDb.transaction('keyval').objectStore('keyval').getAll(storageKey);
              transitionPromise = new Promise(function (resolve) {
                getAllRequest_1.onsuccess = function (e) {
                  return __awaiter(_this, void 0, void 0, function () {
                    var storedReplaySessionContextList, storedReplaySessionContexts, promisesToBatch_1;
                    var _this = this;
                    return __generator(this, function (_a) {
                      switch (_a.label) {
                        case 0:
                          storedReplaySessionContextList = e && e.target.result;
                          storedReplaySessionContexts = storedReplaySessionContextList && storedReplaySessionContextList[0];
                          if (!storedReplaySessionContexts) return [3 /*break*/, 2];
                          promisesToBatch_1 = [];
                          Object.keys(storedReplaySessionContexts).forEach(function (storedSessionId) {
                            var numericSessionId = parseInt(storedSessionId, 10);
                            var oldSessionStore = storedReplaySessionContexts[numericSessionId];
                            if (sessionId === numericSessionId) {
                              promisesToBatch_1.push(transitionCurrentSessionSequences_1(numericSessionId, oldSessionStore));
                            } else {
                              var oldSessionSequences_1 = oldSessionStore.sessionSequences;
                              Object.keys(oldSessionSequences_1).forEach(function (sequenceId) {
                                var numericSequenceId = parseInt(sequenceId, 10);
                                if (oldSessionSequences_1[numericSequenceId].status !== RecordingStatus.SENT) {
                                  promisesToBatch_1.push(_this.storeSendingEvents(numericSessionId, oldSessionSequences_1[numericSequenceId].events));
                                }
                              });
                            }
                          });
                          return [4 /*yield*/, batchPromiseAll(promisesToBatch_1)];
                        case 1:
                          _a.sent();
                          _a.label = 2;
                        case 2:
                          resolve();
                          return [2 /*return*/];
                      }
                    });
                  });
                };
              });
              return [4 /*yield*/, transitionPromise];
            case 3:
              _a.sent();
              globalScope = getGlobalScope();
              if (globalScope) {
                globalScope.indexedDB.deleteDatabase('keyval-store');
              }
              return [3 /*break*/, 5];
            case 4:
              e_6 = _a.sent();
              this.loggerProvider.warn("Failed to transition session replay events from keyval to new store: ".concat(e_6));
              return [3 /*break*/, 5];
            case 5:
              return [3 /*break*/, 7];
            case 6:
              e_7 = _a.sent();
              this.loggerProvider.warn("Failed to access keyval store: ".concat(e_7, ". For more information, visit: https://www.docs.developers.amplitude.com/session-replay/sdks/standalone/#indexeddb-best-practices"));
              return [3 /*break*/, 7];
            case 7:
              return [2 /*return*/];
          }
        });
      });
    };
    _this.apiKey = args.apiKey;
    _this.db = args.db;
    return _this;
  }
  SessionReplayEventsIDBStore.new = function (type, args, sessionId) {
    return __awaiter(this, void 0, void 0, function () {
      var dbSuffix, dbName, db, eventsIDBStore, e_8;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);
            dbSuffix = type === 'replay' ? '' : "_".concat(type);
            dbName = "".concat(args.apiKey.substring(0, 10), "_amp_session_replay_events").concat(dbSuffix);
            return [4 /*yield*/, createStore(dbName)];
          case 1:
            db = _a.sent();
            eventsIDBStore = new SessionReplayEventsIDBStore(_assign$(_assign$({}, args), {
              db: db
            }));
            return [4 /*yield*/, eventsIDBStore.transitionFromKeyValStore(sessionId)];
          case 2:
            _a.sent();
            return [2 /*return*/, eventsIDBStore];
          case 3:
            e_8 = _a.sent();
            args.loggerProvider.warn("".concat(STORAGE_FAILURE, ": ").concat(e_8));
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplayEventsIDBStore.prototype.getCurrentSequenceEvents = function (sessionId) {
    return __awaiter(this, void 0, void 0, function () {
      var events, allEvents, _a, _b, events, e_9_1;
      var e_9, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!sessionId) return [3 /*break*/, 2];
            return [4 /*yield*/, this.db.get('sessionCurrentSequence', sessionId)];
          case 1:
            events = _d.sent();
            if (!events) {
              return [2 /*return*/, undefined];
            }
            return [2 /*return*/, [events]];
          case 2:
            allEvents = [];
            _d.label = 3;
          case 3:
            _d.trys.push([3, 8, 9, 10]);
            return [4 /*yield*/, this.db.getAll('sessionCurrentSequence')];
          case 4:
            _a = __values$1.apply(void 0, [_d.sent()]), _b = _a.next();
            _d.label = 5;
          case 5:
            if (!!_b.done) return [3 /*break*/, 7];
            events = _b.value;
            allEvents.push(events);
            _d.label = 6;
          case 6:
            _b = _a.next();
            return [3 /*break*/, 5];
          case 7:
            return [3 /*break*/, 10];
          case 8:
            e_9_1 = _d.sent();
            e_9 = {
              error: e_9_1
            };
            return [3 /*break*/, 10];
          case 9:
            try {
              if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            } finally {
              if (e_9) throw e_9.error;
            }
            return [7 /*endfinally*/];
          case 10:
            return [2 /*return*/, allEvents];
        }
      });
    });
  };
  return SessionReplayEventsIDBStore;
}(BaseEventsStore);
var InMemoryEventsStore = /** @class */function (_super) {
  __extends(InMemoryEventsStore, _super);
  function InMemoryEventsStore() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.finalizedSequences = {};
    _this.sequences = {};
    _this.sequenceId = 0;
    return _this;
  }
  InMemoryEventsStore.prototype.resetCurrentSequence = function (sessionId) {
    this.sequences[sessionId] = [];
  };
  InMemoryEventsStore.prototype.addSequence = function (sessionId) {
    var sequenceId = this.sequenceId++;
    var events = __spreadArray([], __read$1(this.sequences[sessionId]), false);
    this.finalizedSequences[sequenceId] = {
      sessionId: sessionId,
      events: events
    };
    this.resetCurrentSequence(sessionId);
    return {
      sequenceId: sequenceId,
      events: events,
      sessionId: sessionId
    };
  };
  InMemoryEventsStore.prototype.getSequencesToSend = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, Object.entries(this.finalizedSequences).map(function (_a) {
          var _b = __read$1(_a, 2),
            sequenceId = _b[0],
            _c = _b[1],
            sessionId = _c.sessionId,
            events = _c.events;
          return {
            sequenceId: Number(sequenceId),
            sessionId: sessionId,
            events: events
          };
        })];
      });
    });
  };
  InMemoryEventsStore.prototype.storeCurrentSequence = function (sessionId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!this.sequences[sessionId]) {
          return [2 /*return*/, undefined];
        }
        return [2 /*return*/, this.addSequence(sessionId)];
      });
    });
  };
  InMemoryEventsStore.prototype.addEventToCurrentSequence = function (sessionId, event) {
    return __awaiter(this, void 0, void 0, function () {
      var sequenceReturn;
      return __generator(this, function (_a) {
        if (!this.sequences[sessionId]) {
          this.resetCurrentSequence(sessionId);
        }
        if (this.shouldSplitEventsList(this.sequences[sessionId], event)) {
          sequenceReturn = this.addSequence(sessionId);
        }
        this.sequences[sessionId].push(event);
        return [2 /*return*/, sequenceReturn];
      });
    });
  };
  InMemoryEventsStore.prototype.storeSendingEvents = function (sessionId, events) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.finalizedSequences[this.sequenceId] = {
          sessionId: sessionId,
          events: events
        };
        return [2 /*return*/, this.sequenceId++];
      });
    });
  };
  InMemoryEventsStore.prototype.cleanUpSessionEventsStore = function (_sessionId, sequenceId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (sequenceId !== undefined) {
          delete this.finalizedSequences[sequenceId];
        }
        return [2 /*return*/];
      });
    });
  };
  return InMemoryEventsStore;
}(BaseEventsStore);
var createEventsManager = function createEventsManager(_a) {
  var config = _a.config,
    sessionId = _a.sessionId,
    minInterval = _a.minInterval,
    maxInterval = _a.maxInterval,
    type = _a.type,
    payloadBatcher = _a.payloadBatcher,
    storeType = _a.storeType;
  return __awaiter(void 0, void 0, void 0, function () {
    function flush(useRetry) {
      if (useRetry === void 0) {
        useRetry = false;
      }
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2 /*return*/, trackDestination.flush(useRetry)];
        });
      });
    }
    var trackDestination, getMemoryStore, getIdbStoreOrFallback, store, _b, sendEventsList, sendCurrentSequenceEvents, sendStoredEvents, addEvent;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          trackDestination = new SessionReplayTrackDestination(_assign$(_assign$({}, config), {
            loggerProvider: config.loggerProvider,
            payloadBatcher: payloadBatcher
          }));
          getMemoryStore = function () {
            return new InMemoryEventsStore({
              loggerProvider: config.loggerProvider,
              maxInterval: maxInterval,
              minInterval: minInterval
            });
          };
          getIdbStoreOrFallback = function () {
            return __awaiter(void 0, void 0, void 0, function () {
              var store;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, SessionReplayEventsIDBStore.new(type, {
                      loggerProvider: config.loggerProvider,
                      minInterval: minInterval,
                      maxInterval: maxInterval,
                      apiKey: config.apiKey
                    }, sessionId)];
                  case 1:
                    store = _a.sent();
                    config.loggerProvider.log('Failed to initialize idb store, falling back to memory store.');
                    return [2 /*return*/, store !== null && store !== void 0 ? store : getMemoryStore()];
                }
              });
            });
          };
          if (!(storeType === 'idb')) return [3 /*break*/, 2];
          return [4 /*yield*/, getIdbStoreOrFallback()];
        case 1:
          _b = _c.sent();
          return [3 /*break*/, 3];
        case 2:
          _b = getMemoryStore();
          _c.label = 3;
        case 3:
          store = _b;
          sendEventsList = function (_a) {
            var events = _a.events,
              sessionId = _a.sessionId,
              deviceId = _a.deviceId,
              sequenceId = _a.sequenceId;
            if (config.debugMode) {
              getStorageSize().then(function (_a) {
                var totalStorageSize = _a.totalStorageSize,
                  percentOfQuota = _a.percentOfQuota,
                  usageDetails = _a.usageDetails;
                config.loggerProvider.debug("Total storage size: ".concat(totalStorageSize, " KB, percentage of quota: ").concat(percentOfQuota, "%, usage details: ").concat(usageDetails));
              }).catch(function () {
                // swallow error
              });
            }
            trackDestination.sendEventsList({
              events: events,
              sessionId: sessionId,
              flushMaxRetries: config.flushMaxRetries,
              apiKey: config.apiKey,
              deviceId: deviceId,
              sampleRate: config.sampleRate,
              serverZone: config.serverZone,
              version: config.version,
              type: type,
              onComplete: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        return [4 /*yield*/, store.cleanUpSessionEventsStore(sessionId, sequenceId)];
                      case 1:
                        _a.sent();
                        return [2 /*return*/];
                    }
                  });
                });
              }
            });
          };
          sendCurrentSequenceEvents = function (_a) {
            var sessionId = _a.sessionId,
              deviceId = _a.deviceId;
            store.storeCurrentSequence(sessionId).then(function (currentSequence) {
              if (currentSequence) {
                sendEventsList({
                  sequenceId: currentSequence.sequenceId,
                  events: currentSequence.events,
                  sessionId: currentSequence.sessionId,
                  deviceId: deviceId
                });
              }
            }).catch(function (e) {
              config.loggerProvider.warn('Failed to get current sequence of session replay events for session:', e);
            });
          };
          sendStoredEvents = function (_a) {
            var deviceId = _a.deviceId;
            return __awaiter(void 0, void 0, void 0, function () {
              var sequencesToSend;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    return [4 /*yield*/, store.getSequencesToSend()];
                  case 1:
                    sequencesToSend = _b.sent();
                    sequencesToSend && sequencesToSend.forEach(function (sequence) {
                      sendEventsList({
                        sequenceId: sequence.sequenceId,
                        events: sequence.events,
                        sessionId: sequence.sessionId,
                        deviceId: deviceId
                      });
                    });
                    return [2 /*return*/];
                }
              });
            });
          };
          addEvent = function (_a) {
            var event = _a.event,
              sessionId = _a.sessionId,
              deviceId = _a.deviceId;
            store.addEventToCurrentSequence(sessionId, event.data).then(function (sequenceToSend) {
              return sequenceToSend && sendEventsList({
                sequenceId: sequenceToSend.sequenceId,
                events: sequenceToSend.events,
                sessionId: sequenceToSend.sessionId,
                deviceId: deviceId
              });
            }).catch(function (e) {
              config.loggerProvider.warn('Failed to add event to session replay capture:', e);
            });
          };
          return [2 /*return*/, {
            sendCurrentSequenceEvents: sendCurrentSequenceEvents,
            addEvent: addEvent,
            sendStoredEvents: sendStoredEvents,
            flush: flush
          }];
      }
    });
  });
};

/**
 * "Registers" events managers internally. When an event is added this class routes the event to the correct
 * manager. For all send or flush methods this will invoke the event for all registered managers.
 */
var MultiEventManager = /** @class */function () {
  function MultiEventManager() {
    var managers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      managers[_i] = arguments[_i];
    }
    var managersMap = new Map();
    managers.forEach(function (t) {
      managersMap.set(t.name, t.manager);
    });
    this.managers = managersMap;
  }
  MultiEventManager.prototype.sendStoredEvents = function (opts) {
    return __awaiter(this, void 0, void 0, function () {
      var promises;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            promises = [];
            this.managers.forEach(function (manager) {
              promises.push(manager.sendStoredEvents(opts));
            });
            return [4 /*yield*/, Promise.all(promises)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  MultiEventManager.prototype.addEvent = function (_a) {
    var _b;
    var sessionId = _a.sessionId,
      event = _a.event,
      deviceId = _a.deviceId;
    (_b = this.managers.get(event.type)) === null || _b === void 0 ? void 0 : _b.addEvent({
      sessionId: sessionId,
      event: event,
      deviceId: deviceId
    });
  };
  MultiEventManager.prototype.sendCurrentSequenceEvents = function (_a) {
    var sessionId = _a.sessionId,
      deviceId = _a.deviceId;
    this.managers.forEach(function (manager) {
      manager.sendCurrentSequenceEvents({
        sessionId: sessionId,
        deviceId: deviceId
      });
    });
  };
  MultiEventManager.prototype.flush = function (useRetry) {
    return __awaiter(this, void 0, void 0, function () {
      var promises;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            promises = [];
            this.managers.forEach(function (manager) {
              promises.push(manager.flush(useRetry));
            });
            return [4 /*yield*/, Promise.all(promises)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  return MultiEventManager;
}();
const testableAccessors = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
};
const testableMethods = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
};
const untaintedBasePrototype = {};
function angularZoneUnpatchedAlternative(key) {
  var _a, _b;
  const angularUnpatchedVersionSymbol = (_b = (_a = globalThis == null ? void 0 : globalThis.Zone) == null ? void 0 : _a.__symbol__) == null ? void 0 : _b.call(_a, key);
  if (angularUnpatchedVersionSymbol && globalThis[angularUnpatchedVersionSymbol]) {
    return globalThis[angularUnpatchedVersionSymbol];
  } else {
    return void 0;
  }
}
function getUntaintedPrototype(key) {
  if (untaintedBasePrototype[key]) return untaintedBasePrototype[key];
  const candidate = angularZoneUnpatchedAlternative(key) || globalThis[key];
  const defaultPrototype = candidate.prototype;
  const accessorNames = key in testableAccessors ? testableAccessors[key] : void 0;
  const isUntaintedAccessors = Boolean(accessorNames &&
  // @ts-expect-error 2345
  accessorNames.every(accessor => {
    var _a, _b;
    return Boolean((_b = (_a = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a.get) == null ? void 0 : _b.toString().includes("[native code]"));
  }));
  const methodNames = key in testableMethods ? testableMethods[key] : void 0;
  const isUntaintedMethods = Boolean(methodNames && methodNames.every(
  // @ts-expect-error 2345
  method => {
    var _a;
    return typeof defaultPrototype[method] === "function" && ((_a = defaultPrototype[method]) == null ? void 0 : _a.toString().includes("[native code]"));
  }));
  if (isUntaintedAccessors && isUntaintedMethods) {
    untaintedBasePrototype[key] = candidate.prototype;
    return candidate.prototype;
  }
  try {
    const iframeEl = document.createElement("iframe");
    document.body.appendChild(iframeEl);
    const win = iframeEl.contentWindow;
    if (!win) return candidate.prototype;
    const untaintedObject = win[key].prototype;
    document.body.removeChild(iframeEl);
    if (!untaintedObject) return defaultPrototype;
    return untaintedBasePrototype[key] = untaintedObject;
  } catch (_unused) {
    return defaultPrototype;
  }
}
const untaintedAccessorCache = {};
function getUntaintedAccessor(key, instance, accessor) {
  var _a;
  const cacheKey = `${key}.${String(accessor)}`;
  if (untaintedAccessorCache[cacheKey]) return untaintedAccessorCache[cacheKey].call(instance);
  const untaintedPrototype = getUntaintedPrototype(key);
  const untaintedAccessor = (_a = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a.get;
  if (!untaintedAccessor) return instance[accessor];
  untaintedAccessorCache[cacheKey] = untaintedAccessor;
  return untaintedAccessor.call(instance);
}
const untaintedMethodCache = {};
function getUntaintedMethod(key, instance, method) {
  const cacheKey = `${key}.${String(method)}`;
  if (untaintedMethodCache[cacheKey]) return untaintedMethodCache[cacheKey].bind(instance);
  const untaintedPrototype = getUntaintedPrototype(key);
  const untaintedMethod = untaintedPrototype[method];
  if (typeof untaintedMethod !== "function") return instance[method];
  untaintedMethodCache[cacheKey] = untaintedMethod;
  return untaintedMethod.bind(instance);
}
function childNodes(n) {
  return getUntaintedAccessor("Node", n, "childNodes");
}
function parentNode(n) {
  return getUntaintedAccessor("Node", n, "parentNode");
}
function parentElement(n) {
  return getUntaintedAccessor("Node", n, "parentElement");
}
function textContent(n) {
  return getUntaintedAccessor("Node", n, "textContent");
}
function contains(n, other) {
  return getUntaintedMethod("Node", n, "contains")(other);
}
function getRootNode(n) {
  return getUntaintedMethod("Node", n, "getRootNode")();
}
function host(n) {
  if (!n || !("host" in n)) return null;
  return getUntaintedAccessor("ShadowRoot", n, "host");
}
function styleSheets(n) {
  return n.styleSheets;
}
function shadowRoot(n) {
  if (!n || !("shadowRoot" in n)) return null;
  return getUntaintedAccessor("Element", n, "shadowRoot");
}
function querySelector(n, selectors) {
  return getUntaintedAccessor("Element", n, "querySelector")(selectors);
}
function querySelectorAll(n, selectors) {
  return getUntaintedAccessor("Element", n, "querySelectorAll")(selectors);
}
function mutationObserverCtor() {
  return getUntaintedPrototype("MutationObserver").constructor;
}
const index$1 = {
  childNodes,
  parentNode,
  parentElement,
  textContent,
  contains,
  getRootNode,
  host,
  styleSheets,
  shadowRoot,
  querySelector,
  querySelectorAll,
  mutationObserver: mutationObserverCtor
};

// These functions are not exposed in rrweb package, so we will define it here to use
// Ignoring this function since this is copied from rrweb
/* istanbul ignore next */
function getWindowScroll(win) {
  var _a, _b, _c, _d;
  var doc = win.document;
  return {
    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : doc.documentElement.scrollLeft || (doc === null || doc === void 0 ? void 0 : doc.body) && ((_a = index$1.parentElement(doc.body)) === null || _a === void 0 ? void 0 : _a.scrollLeft) || ((_b = doc === null || doc === void 0 ? void 0 : doc.body) === null || _b === void 0 ? void 0 : _b.scrollLeft) || 0,
    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || (doc === null || doc === void 0 ? void 0 : doc.body) && ((_c = index$1.parentElement(doc.body)) === null || _c === void 0 ? void 0 : _c.scrollTop) || ((_d = doc === null || doc === void 0 ? void 0 : doc.body) === null || _d === void 0 ? void 0 : _d.scrollTop) || 0
  };
}
function getWindowHeight() {
  var globalScope = getGlobalScope();
  return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerHeight) || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight || 0;
}
function getWindowWidth() {
  var globalScope = getGlobalScope();
  return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerWidth) || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth || 0;
}

/* istanbul ignore file */
var config;
var rootDocument;
var start;
function finder(input, options) {
  start = new Date();
  if (input.nodeType !== Node.ELEMENT_NODE) {
    throw new Error("Can't generate CSS selector for non-element node type.");
  }
  if ('html' === input.tagName.toLowerCase()) {
    return 'html';
  }
  var defaults = {
    root: document.body,
    idName: function (_name) {
      return true;
    },
    className: function (_name) {
      return true;
    },
    tagName: function (_name) {
      return true;
    },
    attr: function (_name, _value) {
      return false;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1000,
    maxNumberOfTries: 10000,
    timeoutMs: undefined
  };
  config = _assign$(_assign$({}, defaults), options);
  rootDocument = findRootDocument(config.root, defaults);
  var path = bottomUpSearch(input, 'all', function () {
    return bottomUpSearch(input, 'two', function () {
      return bottomUpSearch(input, 'one', function () {
        return bottomUpSearch(input, 'none');
      });
    });
  });
  if (path) {
    var optimized = sort(optimize(path, input));
    if (optimized.length > 0) {
      path = optimized[0];
    }
    return selector(path);
  } else {
    throw new Error("Selector was not found.");
  }
}
function findRootDocument(rootNode, defaults) {
  if (rootNode.nodeType === Node.DOCUMENT_NODE) {
    return rootNode;
  }
  if (rootNode === defaults.root) {
    return rootNode.ownerDocument;
  }
  return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
  var path = null;
  var stack = [];
  var current = input;
  var i = 0;
  var _loop_1 = function _loop_1() {
    var e_1, _a;
    var elapsedTime = new Date().getTime() - start.getTime();
    if (config.timeoutMs !== undefined && elapsedTime > config.timeoutMs) {
      throw new Error("Timeout: Can't find a unique selector after ".concat(elapsedTime, "ms"));
    }
    var level = maybe(id(current)) || maybe.apply(void 0, __spreadArray([], __read$1(attr(current)), false)) || maybe.apply(void 0, __spreadArray([], __read$1(classNames(current)), false)) || maybe(tagName(current)) || [any()];
    var nth = index(current);
    if (limit == 'all') {
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'two') {
      level = level.slice(0, 1);
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'one') {
      var _b = __read$1(level = level.slice(0, 1), 1),
        node = _b[0];
      if (nth && dispensableNth(node)) {
        level = [nthChild(node, nth)];
      }
    } else if (limit == 'none') {
      level = [any()];
      if (nth) {
        level = [nthChild(level[0], nth)];
      }
    }
    try {
      for (var level_1 = (e_1 = void 0, __values$1(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()) {
        var node = level_1_1.value;
        node.level = i;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    stack.push(level);
    if (stack.length >= config.seedMinLength) {
      path = findUniquePath(stack, fallback);
      if (path) {
        return "break";
      }
    }
    current = current.parentElement;
    i++;
  };
  while (current) {
    var state_1 = _loop_1();
    if (state_1 === "break") break;
  }
  if (!path) {
    path = findUniquePath(stack, fallback);
  }
  if (!path && fallback) {
    return fallback();
  }
  return path;
}
function findUniquePath(stack, fallback) {
  var e_2, _a;
  var paths = sort(combinations(stack));
  if (paths.length > config.threshold) {
    return fallback ? fallback() : null;
  }
  try {
    for (var paths_1 = __values$1(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
      var candidate = paths_1_1.value;
      if (unique(candidate)) {
        return candidate;
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return null;
}
function selector(path) {
  var node = path[0];
  var query = node.name;
  for (var i = 1; i < path.length; i++) {
    var level = path[i].level || 0;
    if (node.level === level - 1) {
      query = "".concat(path[i].name, " > ").concat(query);
    } else {
      query = "".concat(path[i].name, " ").concat(query);
    }
    node = path[i];
  }
  return query;
}
function penalty(path) {
  return path.map(function (node) {
    return node.penalty;
  }).reduce(function (acc, i) {
    return acc + i;
  }, 0);
}
function unique(path) {
  var css = selector(path);
  switch (rootDocument.querySelectorAll(css).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(css));
    case 1:
      return true;
    default:
      return false;
  }
}
function id(input) {
  var elementId = input.getAttribute('id');
  if (elementId && config.idName(elementId)) {
    return {
      name: '#' + CSS.escape(elementId),
      penalty: 0
    };
  }
  return null;
}
function attr(input) {
  var attrs = Array.from(input.attributes).filter(function (attr) {
    return config.attr(attr.name, attr.value);
  });
  return attrs.map(function (attr) {
    return {
      name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
      penalty: 0.5
    };
  });
}
function classNames(input) {
  var names = Array.from(input.classList).filter(config.className);
  return names.map(function (name) {
    return {
      name: '.' + CSS.escape(name),
      penalty: 1
    };
  });
}
function tagName(input) {
  var name = input.tagName.toLowerCase();
  if (config.tagName(name)) {
    return {
      name: name,
      penalty: 2
    };
  }
  return null;
}
function any() {
  return {
    name: '*',
    penalty: 3
  };
}
function index(input) {
  var parent = input.parentNode;
  if (!parent) {
    return null;
  }
  var child = parent.firstChild;
  if (!child) {
    return null;
  }
  var i = 0;
  while (child) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      i++;
    }
    if (child === input) {
      break;
    }
    child = child.nextSibling;
  }
  return i;
}
function nthChild(node, i) {
  return {
    name: node.name + ":nth-child(".concat(i, ")"),
    penalty: node.penalty + 1
  };
}
function dispensableNth(node) {
  return node.name !== 'html' && !node.name.startsWith('#');
}
function maybe() {
  var level = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    level[_i] = arguments[_i];
  }
  var list = level.filter(notEmpty);
  if (list.length > 0) {
    return list;
  }
  return null;
}
function notEmpty(value) {
  return value !== null && value !== undefined;
}
function combinations(stack, path) {
  var _a, _b, node, e_3_1;
  var e_3, _c;
  if (path === void 0) {
    path = [];
  }
  return __generator(this, function (_d) {
    switch (_d.label) {
      case 0:
        if (!(stack.length > 0)) return [3 /*break*/, 9];
        _d.label = 1;
      case 1:
        _d.trys.push([1, 6, 7, 8]);
        _a = __values$1(stack[0]), _b = _a.next();
        _d.label = 2;
      case 2:
        if (!!_b.done) return [3 /*break*/, 5];
        node = _b.value;
        return [5 /*yield**/, __values$1(combinations(stack.slice(1, stack.length), path.concat(node)))];
      case 3:
        _d.sent();
        _d.label = 4;
      case 4:
        _b = _a.next();
        return [3 /*break*/, 2];
      case 5:
        return [3 /*break*/, 8];
      case 6:
        e_3_1 = _d.sent();
        e_3 = {
          error: e_3_1
        };
        return [3 /*break*/, 8];
      case 7:
        try {
          if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        } finally {
          if (e_3) throw e_3.error;
        }
        return [7 /*endfinally*/];
      case 8:
        return [3 /*break*/, 11];
      case 9:
        return [4 /*yield*/, path];
      case 10:
        _d.sent();
        _d.label = 11;
      case 11:
        return [2 /*return*/];
    }
  });
}
function sort(paths) {
  return __spreadArray([], __read$1(paths), false).sort(function (a, b) {
    return penalty(a) - penalty(b);
  });
}
function optimize(path, input, scope) {
  var i, newPath, newPathKey;
  if (scope === void 0) {
    scope = {
      counter: 0,
      visited: new Map()
    };
  }
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        if (!(path.length > 2 && path.length > config.optimizedMinLength)) return [3 /*break*/, 5];
        i = 1;
        _a.label = 1;
      case 1:
        if (!(i < path.length - 1)) return [3 /*break*/, 5];
        if (scope.counter > config.maxNumberOfTries) {
          return [2 /*return*/]; // Okay At least I tried!
        }
        scope.counter += 1;
        newPath = __spreadArray([], __read$1(path), false);
        newPath.splice(i, 1);
        newPathKey = selector(newPath);
        if (scope.visited.has(newPathKey)) {
          return [2 /*return*/];
        }
        if (!(unique(newPath) && same(newPath, input))) return [3 /*break*/, 4];
        return [4 /*yield*/, newPath];
      case 2:
        _a.sent();
        scope.visited.set(newPathKey, true);
        return [5 /*yield**/, __values$1(optimize(newPath, input, scope))];
      case 3:
        _a.sent();
        _a.label = 4;
      case 4:
        i++;
        return [3 /*break*/, 1];
      case 5:
        return [2 /*return*/];
    }
  });
}
function same(path, input) {
  return rootDocument.querySelector(selector(path)) === input;
}
var HOUR_IN_MILLISECONDS = 3600000;
var clickNonBatcher = function clickNonBatcher(_a) {
  var version = _a.version,
    events = _a.events;
  var clickEvents = [];
  events.forEach(function (evt) {
    var record = JSON.parse(evt);
    record.count = 1;
    if (record.type === 'click') {
      clickEvents.push(record);
    }
  });
  return {
    version: version,
    events: clickEvents
  };
};
var clickBatcher = function clickBatcher(_a) {
  var version = _a.version,
    events = _a.events;
  var clickEvents = [];
  events.forEach(function (evt) {
    var record = JSON.parse(evt);
    if (record.type === 'click') {
      clickEvents.push(record);
    }
  });
  var reduced = clickEvents.reduce(function (prev, curr) {
    var x = curr.x,
      y = curr.y,
      selector = curr.selector,
      timestamp = curr.timestamp;
    // round down to nearest hour.
    var hour = timestamp - timestamp % HOUR_IN_MILLISECONDS;
    var k = "".concat(x, ":").concat(y, ":").concat(selector !== null && selector !== void 0 ? selector : '', ":").concat(hour);
    if (!prev[k]) {
      prev[k] = _assign$(_assign$({}, curr), {
        timestamp: hour,
        count: 1
      });
    } else {
      prev[k].count += 1;
    }
    return prev;
  }, {});
  return {
    version: version,
    events: Object.values(reduced)
  };
};
var clickHook = function clickHook(logger, _a) {
  var eventsManager = _a.eventsManager,
    sessionId = _a.sessionId,
    deviceIdFn = _a.deviceIdFn,
    mirror = _a.mirror,
    ugcFilterRules = _a.ugcFilterRules;
  return function (e) {
    if (e.type !== MouseInteractions.Click) {
      return;
    }
    var globalScope = getGlobalScope();
    if (!globalScope) {
      return;
    }
    var location = globalScope.location,
      innerHeight = globalScope.innerHeight,
      innerWidth = globalScope.innerWidth;
    // it only makes sense to send events if a pageUrl exists
    if (!location) {
      return;
    }
    var x = e.x,
      y = e.y;
    if (x === undefined || y === undefined) {
      return;
    }
    var node = mirror.getNode(e.id);
    var selector;
    if (node) {
      try {
        selector = finder(node);
      } catch (err) {
        logger.debug('error resolving selector from finder');
      }
    }
    var _a = getWindowScroll(globalScope),
      scrollX = _a.left,
      scrollY = _a.top;
    var pageUrl = getPageUrl(location.href, ugcFilterRules);
    var event = {
      x: x + scrollX,
      y: y + scrollY,
      selector: selector,
      viewportHeight: innerHeight,
      viewportWidth: innerWidth,
      pageUrl: pageUrl,
      timestamp: Date.now(),
      type: 'click'
    };
    var deviceId = deviceIdFn();
    if (deviceId) {
      eventsManager.addEvent({
        sessionId: sessionId,
        event: {
          type: 'interaction',
          data: JSON.stringify(event)
        },
        deviceId: deviceId
      });
    }
  };
};

/**
 * For very small payloads it's preferable to use the [Beacon API](https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API).
 * While it doesn't provide 100% guarantees on sends, it greatly helps with overall reliability and page load performance. As
 * the Beacon API has a potential to fail due to size constraints we want to fall back to XHR if need be. This is mostly to
 * be used with 'pagehide' or 'beforeunload' events.
 *
 * Note there are only 3 CORS safelisted Content-Types you can send:
 *
 * - application/x-www-form-urlencoded
 * - multipart/form-data
 * - text/plain
 *
 * If we do not send one of these, some browsers like Chrome may not send this at all. Also we incur the overhead of a preflight
 * request. In our case we will add no additional content-type header. If you are trying to ping a server that requires this
 * header, you may want to use the regular fetch API or a different mechanism.
 */
var BeaconTransport = /** @class */function () {
  function BeaconTransport(context, config) {
    var globalScope = getGlobalScope();
    if (globalScope && globalScope.navigator && typeof globalScope.navigator.sendBeacon === 'function') {
      this.sendBeacon = function (pageUrl, payload) {
        try {
          if (globalScope.navigator.sendBeacon(pageUrl, JSON.stringify(payload))) {
            return true;
          }
        } catch (e) {
          // not logging error, since it would be hard to view and just adds overhead.
        }
        return false;
      };
    } else {
      this.sendBeacon = function () {
        return false;
      };
    }
    this.sendXhr = function (pageUrl, payload) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', pageUrl, true);
      xhr.setRequestHeader('Accept', '*/*');
      xhr.send(JSON.stringify(payload));
      return true;
    };
    this.basePageUrl = getServerUrl(config.serverZone, config.trackServerUrl);
    this.apiKey = config.apiKey;
    this.context = context;
  }
  BeaconTransport.prototype.send = function (deviceId, payload) {
    var _a = this.context,
      sessionId = _a.sessionId,
      type = _a.type;
    var urlParams = new URLSearchParams({
      device_id: deviceId,
      session_id: String(sessionId),
      type: String(type),
      api_key: this.apiKey
    });
    var pageUrl = "".concat(this.basePageUrl, "?").concat(urlParams.toString());
    // ideally send using the beacon API, but there is a chance it may fail, possibly due to a payload
    // size limit. in this case, try best effort to send using xhr.
    this.sendBeacon(pageUrl, payload) || this.sendXhr(pageUrl, payload);
  };
  return BeaconTransport;
}();

/**
 * This is intended to watch and update max scroll activity when loaded for a particular page.
 * A new instance should be created if the page URL changes, since by default it does not reset
 * it's max scroll state. It is intended to send very few and very small events utilizing the
 * Beacon API.
 * @see {@link BeaconTransport} for more details on Beacon API usage.
 */
var ScrollWatcher = /** @class */function () {
  function ScrollWatcher(transport, config) {
    var _this = this;
    this.timestamp = Date.now();
    this.hook = function (e) {
      _this.update(e);
    };
    this.send = function (deviceIdFn) {
      return function (_) {
        var _a, _b;
        var deviceId = deviceIdFn();
        var globalScope = getGlobalScope();
        if (globalScope && deviceId) {
          _this.transport.send(deviceId, {
            version: 1,
            events: [{
              maxScrollX: _this._maxScrollX,
              maxScrollY: _this._maxScrollY,
              maxScrollWidth: _this._maxScrollWidth,
              maxScrollHeight: _this._maxScrollHeight,
              viewportHeight: getWindowHeight(),
              viewportWidth: getWindowWidth(),
              pageUrl: getPageUrl(globalScope.location.href, (_b = (_a = _this.config.interactionConfig) === null || _a === void 0 ? void 0 : _a.ugcFilterRules) !== null && _b !== void 0 ? _b : []),
              timestamp: _this.timestamp,
              type: 'scroll'
            }]
          });
        }
      };
    };
    this._maxScrollX = 0;
    this._maxScrollY = 0;
    this._maxScrollWidth = getWindowWidth();
    this._maxScrollHeight = getWindowHeight();
    this.config = config;
    this.transport = transport;
  }
  ScrollWatcher.default = function (context, config) {
    return new ScrollWatcher(new BeaconTransport(context, config), config);
  };
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollX", {
    get: function () {
      return this._maxScrollX;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollY", {
    get: function () {
      return this._maxScrollY;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollWidth", {
    get: function () {
      return this._maxScrollWidth;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScrollWatcher.prototype, "maxScrollHeight", {
    get: function () {
      return this._maxScrollHeight;
    },
    enumerable: false,
    configurable: true
  });
  ScrollWatcher.prototype.update = function (e) {
    var now = Date.now();
    if (e.x > this._maxScrollX) {
      var width = getWindowWidth();
      this._maxScrollX = e.x;
      var maxScrollWidth = e.x + width;
      if (maxScrollWidth > this._maxScrollWidth) {
        this._maxScrollWidth = maxScrollWidth;
      }
      this.timestamp = now;
    }
    if (e.y > this._maxScrollY) {
      var height = getWindowHeight();
      this._maxScrollY = e.y;
      var maxScrollHeight = e.y + height;
      if (maxScrollHeight > this._maxScrollHeight) {
        this._maxScrollHeight = maxScrollHeight;
      }
      this.timestamp = now;
    }
  };
  return ScrollWatcher;
}();
var SessionIdentifiers = /** @class */function () {
  function SessionIdentifiers(_a) {
    var sessionId = _a.sessionId,
      deviceId = _a.deviceId;
    this.deviceId = deviceId;
    this.sessionId = sessionId;
    if (sessionId && deviceId) {
      this.sessionReplayId = generateSessionReplayId(sessionId, deviceId);
    }
  }
  return SessionIdentifiers;
}();
var u8 = Uint8Array,
  u16 = Uint16Array,
  u32 = Uint32Array;
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */
0, 0, /* impossible */
0]);
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */
0, 0]);
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var freb = function freb(eb, start) {
  var b = new u16(31);
  for (var i = 0; i < 31; ++i) {
    b[i] = start += 1 << eb[i - 1];
  }
  var r = new u32(b[30]);
  for (var i = 1; i < 30; ++i) {
    for (var j = b[i]; j < b[i + 1]; ++j) {
      r[j] = j - b[i] << 5 | i;
    }
  }
  return [b, r];
};
var _a = freb(fleb, 2),
  fl = _a[0],
  revfl = _a[1];
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0),
  revfd = _b[1];
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
  var x = (i & 43690) >>> 1 | (i & 21845) << 1;
  x = (x & 52428) >>> 2 | (x & 13107) << 2;
  x = (x & 61680) >>> 4 | (x & 3855) << 4;
  rev[i] = ((x & 65280) >>> 8 | (x & 255) << 8) >>> 1;
}
var hMap = function hMap(cd, mb, r) {
  var s = cd.length;
  var i = 0;
  var l = new u16(mb);
  for (; i < s; ++i) ++l[cd[i] - 1];
  var le = new u16(mb);
  for (i = 0; i < mb; ++i) {
    le[i] = le[i - 1] + l[i - 1] << 1;
  }
  var co;
  if (r) {
    co = new u16(1 << mb);
    var rvb = 15 - mb;
    for (i = 0; i < s; ++i) {
      if (cd[i]) {
        var sv = i << 4 | cd[i];
        var r_1 = mb - cd[i];
        var v = le[cd[i] - 1]++ << r_1;
        for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
          co[rev[v] >>> rvb] = sv;
        }
      }
    }
  } else {
    co = new u16(s);
    for (i = 0; i < s; ++i) co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
  }
  return co;
};
var flt = new u8(288);
for (var i = 0; i < 144; ++i) flt[i] = 8;
for (var i = 144; i < 256; ++i) flt[i] = 9;
for (var i = 256; i < 280; ++i) flt[i] = 7;
for (var i = 280; i < 288; ++i) flt[i] = 8;
var fdt = new u8(32);
for (var i = 0; i < 32; ++i) fdt[i] = 5;
var flm = /* @__PURE__ */hMap(flt, 9, 0);
var fdm = /* @__PURE__ */hMap(fdt, 5, 0);
var shft = function shft(p) {
  return (p / 8 >> 0) + (p & 7 && 1);
};
var slc = function slc(v, s, e) {
  if (e == null || e > v.length) e = v.length;
  var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
  n.set(v.subarray(s, e));
  return n;
};
var wbits = function wbits(d, p, v) {
  v <<= p & 7;
  var o = p / 8 >> 0;
  d[o] |= v;
  d[o + 1] |= v >>> 8;
};
var wbits16 = function wbits16(d, p, v) {
  v <<= p & 7;
  var o = p / 8 >> 0;
  d[o] |= v;
  d[o + 1] |= v >>> 8;
  d[o + 2] |= v >>> 16;
};
var hTree = function hTree(d, mb) {
  var t = [];
  for (var i = 0; i < d.length; ++i) {
    if (d[i]) t.push({
      s: i,
      f: d[i]
    });
  }
  var s = t.length;
  var t2 = t.slice();
  if (!s) return [new u8(0), 0];
  if (s == 1) {
    var v = new u8(t[0].s + 1);
    v[t[0].s] = 1;
    return [v, 1];
  }
  t.sort(function (a, b) {
    return a.f - b.f;
  });
  t.push({
    s: -1,
    f: 25001
  });
  var l = t[0],
    r = t[1],
    i0 = 0,
    i1 = 1,
    i2 = 2;
  t[0] = {
    s: -1,
    f: l.f + r.f,
    l,
    r
  };
  while (i1 != s - 1) {
    l = t[t[i0].f < t[i2].f ? i0++ : i2++];
    r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
    t[i1++] = {
      s: -1,
      f: l.f + r.f,
      l,
      r
    };
  }
  var maxSym = t2[0].s;
  for (var i = 1; i < s; ++i) {
    if (t2[i].s > maxSym) maxSym = t2[i].s;
  }
  var tr = new u16(maxSym + 1);
  var mbt = ln(t[i1 - 1], tr, 0);
  if (mbt > mb) {
    var i = 0,
      dt = 0;
    var lft = mbt - mb,
      cst = 1 << lft;
    t2.sort(function (a, b) {
      return tr[b.s] - tr[a.s] || a.f - b.f;
    });
    for (; i < s; ++i) {
      var i2_1 = t2[i].s;
      if (tr[i2_1] > mb) {
        dt += cst - (1 << mbt - tr[i2_1]);
        tr[i2_1] = mb;
      } else break;
    }
    dt >>>= lft;
    while (dt > 0) {
      var i2_2 = t2[i].s;
      if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;else ++i;
    }
    for (; i >= 0 && dt; --i) {
      var i2_3 = t2[i].s;
      if (tr[i2_3] == mb) {
        --tr[i2_3];
        ++dt;
      }
    }
    mbt = mb;
  }
  return [new u8(tr), mbt];
};
var ln = function ln(n, l, d) {
  return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
var lc = function lc(c) {
  var s = c.length;
  while (s && !c[--s]);
  var cl = new u16(++s);
  var cli = 0,
    cln = c[0],
    cls = 1;
  var w = function w(v) {
    cl[cli++] = v;
  };
  for (var i = 1; i <= s; ++i) {
    if (c[i] == cln && i != s) ++cls;else {
      if (!cln && cls > 2) {
        for (; cls > 138; cls -= 138) w(32754);
        if (cls > 2) {
          w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
          cls = 0;
        }
      } else if (cls > 3) {
        w(cln), --cls;
        for (; cls > 6; cls -= 6) w(8304);
        if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
      }
      while (cls--) w(cln);
      cls = 1;
      cln = c[i];
    }
  }
  return [cl.subarray(0, cli), s];
};
var clen = function clen(cf, cl) {
  var l = 0;
  for (var i = 0; i < cl.length; ++i) l += cf[i] * cl[i];
  return l;
};
var wfblk = function wfblk(out, pos, dat) {
  var s = dat.length;
  var o = shft(pos + 2);
  out[o] = s & 255;
  out[o + 1] = s >>> 8;
  out[o + 2] = out[o] ^ 255;
  out[o + 3] = out[o + 1] ^ 255;
  for (var i = 0; i < s; ++i) out[o + i + 4] = dat[i];
  return (o + 4 + s) * 8;
};
var wblk = function wblk(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
  wbits(out, p++, final);
  ++lf[256];
  var _a2 = hTree(lf, 15),
    dlt = _a2[0],
    mlb = _a2[1];
  var _b2 = hTree(df, 15),
    ddt = _b2[0],
    mdb = _b2[1];
  var _c = lc(dlt),
    lclt = _c[0],
    nlc = _c[1];
  var _d = lc(ddt),
    lcdt = _d[0],
    ndc = _d[1];
  var lcfreq = new u16(19);
  for (var i = 0; i < lclt.length; ++i) lcfreq[lclt[i] & 31]++;
  for (var i = 0; i < lcdt.length; ++i) lcfreq[lcdt[i] & 31]++;
  var _e = hTree(lcfreq, 7),
    lct = _e[0],
    mlcb = _e[1];
  var nlcc = 19;
  for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
  var flen = bl + 5 << 3;
  var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
  var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
  if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
  var lm, ll, dm, dl;
  wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
  if (dtlen < ftlen) {
    lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
    var llm = hMap(lct, mlcb, 0);
    wbits(out, p, nlc - 257);
    wbits(out, p + 5, ndc - 1);
    wbits(out, p + 10, nlcc - 4);
    p += 14;
    for (var i = 0; i < nlcc; ++i) wbits(out, p + 3 * i, lct[clim[i]]);
    p += 3 * nlcc;
    var lcts = [lclt, lcdt];
    for (var it = 0; it < 2; ++it) {
      var clct = lcts[it];
      for (var i = 0; i < clct.length; ++i) {
        var len = clct[i] & 31;
        wbits(out, p, llm[len]), p += lct[len];
        if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
      }
    }
  } else {
    lm = flm, ll = flt, dm = fdm, dl = fdt;
  }
  for (var i = 0; i < li; ++i) {
    if (syms[i] > 255) {
      var len = syms[i] >>> 18 & 31;
      wbits16(out, p, lm[len + 257]), p += ll[len + 257];
      if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
      var dst = syms[i] & 31;
      wbits16(out, p, dm[dst]), p += dl[dst];
      if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
    } else {
      wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    }
  }
  wbits16(out, p, lm[256]);
  return p + ll[256];
};
var deo = /* @__PURE__ */new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
var dflt = function dflt(dat, lvl, plvl, pre, post, lst) {
  var s = dat.length;
  var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7e3)) + post);
  var w = o.subarray(pre, o.length - post);
  var pos = 0;
  if (!lvl || s < 8) {
    for (var i = 0; i <= s; i += 65535) {
      var e = i + 65535;
      if (e < s) {
        pos = wfblk(w, pos, dat.subarray(i, e));
      } else {
        w[i] = lst;
        pos = wfblk(w, pos, dat.subarray(i, s));
      }
    }
  } else {
    var opt = deo[lvl - 1];
    var n = opt >>> 13,
      c = opt & 8191;
    var msk_1 = (1 << plvl) - 1;
    var prev = new u16(32768),
      head = new u16(msk_1 + 1);
    var bs1_1 = Math.ceil(plvl / 3),
      bs2_1 = 2 * bs1_1;
    var hsh = function hsh(i2) {
      return (dat[i2] ^ dat[i2 + 1] << bs1_1 ^ dat[i2 + 2] << bs2_1) & msk_1;
    };
    var syms = new u32(25e3);
    var lf = new u16(288),
      df = new u16(32);
    var lc_1 = 0,
      eb = 0,
      i = 0,
      li = 0,
      wi = 0,
      bs = 0;
    for (; i < s; ++i) {
      var hv = hsh(i);
      var imod = i & 32767;
      var pimod = head[hv];
      prev[imod] = pimod;
      head[hv] = imod;
      if (wi <= i) {
        var rem = s - i;
        if ((lc_1 > 7e3 || li > 24576) && rem > 423) {
          pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
          li = lc_1 = eb = 0, bs = i;
          for (var j = 0; j < 286; ++j) lf[j] = 0;
          for (var j = 0; j < 30; ++j) df[j] = 0;
        }
        var l = 2,
          d = 0,
          ch_1 = c,
          dif = imod - pimod & 32767;
        if (rem > 2 && hv == hsh(i - dif)) {
          var maxn = Math.min(n, rem) - 1;
          var maxd = Math.min(32767, i);
          var ml = Math.min(258, rem);
          while (dif <= maxd && --ch_1 && imod != pimod) {
            if (dat[i + l] == dat[i + l - dif]) {
              var nl = 0;
              for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
              if (nl > l) {
                l = nl, d = dif;
                if (nl > maxn) break;
                var mmd = Math.min(dif, nl - 2);
                var md = 0;
                for (var j = 0; j < mmd; ++j) {
                  var ti = i - dif + j + 32768 & 32767;
                  var pti = prev[ti];
                  var cd = ti - pti + 32768 & 32767;
                  if (cd > md) md = cd, pimod = ti;
                }
              }
            }
            imod = pimod, pimod = prev[imod];
            dif += imod - pimod + 32768 & 32767;
          }
        }
        if (d) {
          syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
          var lin = revfl[l] & 31,
            din = revfd[d] & 31;
          eb += fleb[lin] + fdeb[din];
          ++lf[257 + lin];
          ++df[din];
          wi = i + l;
          ++lc_1;
        } else {
          syms[li++] = dat[i];
          ++lf[dat[i]];
        }
      }
    }
    pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
  }
  return slc(o, 0, pre + shft(pos) + post);
};
var adler = function adler() {
  var a = 1,
    b = 0;
  return {
    p: function (d) {
      var n = a,
        m = b;
      var l = d.length;
      for (var i = 0; i != l;) {
        var e = Math.min(i + 5552, l);
        for (; i < e; ++i) n += d[i], m += n;
        n %= 65521, m %= 65521;
      }
      a = n, b = m;
    },
    d: function () {
      return (a >>> 8 << 16 | (b & 255) << 8 | b >>> 8) + ((a & 255) << 23) * 2;
    }
  };
};
var dopt = function dopt(dat, opt, pre, post, st) {
  return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, true);
};
var wbytes = function wbytes(d, b, v) {
  for (; v; ++b) d[b] = v, v >>>= 8;
};
var zlh = function zlh(c, o) {
  var lv = o.level,
    fl2 = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
  c[0] = 120, c[1] = fl2 << 6 | (fl2 ? 32 - 2 * fl2 : 1);
};
function zlibSync(data, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var a = adler();
  a.p(data);
  var d = dopt(data, opts, 2, 4);
  return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
function strToU8(str, latin1) {
  var l = str.length;
  if (typeof TextEncoder != "undefined") return new TextEncoder().encode(str);
  var ar = new u8(str.length + (str.length >>> 1));
  var ai = 0;
  var w = function w(v) {
    ar[ai++] = v;
  };
  for (var i = 0; i < l; ++i) {
    if (ai + 5 > ar.length) {
      var n = new u8(ai + 8 + (l - i << 1));
      n.set(ar);
      ar = n;
    }
    var c = str.charCodeAt(i);
    if (c < 128 || latin1) w(c);else if (c < 2048) w(192 | c >>> 6), w(128 | c & 63);else if (c > 55295 && c < 57344) c = 65536 + (c & 1023 << 10) | str.charCodeAt(++i) & 1023, w(240 | c >>> 18), w(128 | c >>> 12 & 63), w(128 | c >>> 6 & 63), w(128 | c & 63);else w(224 | c >>> 12), w(128 | c >>> 6 & 63), w(128 | c & 63);
  }
  return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
  var r = "";
  for (var i = 0; i < dat.length;) {
    var c = dat[i++];
    r += String.fromCharCode(c);
  }
  return r;
}
const MARK = "v1";
const pack = event => {
  const _e = Object.assign({}, event, {
    v: MARK
  });
  return strFromU8(zlibSync(strToU8(JSON.stringify(_e))));
};
var DEFAULT_TIMEOUT = 2000;
var EventCompressor = /** @class */function () {
  function EventCompressor(eventsManager, config, deviceId, workerScriptInternal) {
    var _this = this;
    var _a, _b, _c;
    this.taskQueue = [];
    this.isProcessing = false;
    this.compressEvent = function (event) {
      var packedEvent = pack(event);
      return JSON.stringify(packedEvent);
    };
    this.addCompressedEventToManager = function (compressedEvent, sessionId) {
      if (_this.eventsManager && _this.deviceId) {
        _this.eventsManager.addEvent({
          event: {
            type: 'replay',
            data: compressedEvent
          },
          sessionId: sessionId,
          deviceId: _this.deviceId
        });
      }
    };
    this.addCompressedEvent = function (event, sessionId) {
      if (_this.worker) {
        // This indirectly compresses the event.
        _this.worker.postMessage({
          event: event,
          sessionId: sessionId
        });
      } else {
        var compressedEvent = _this.compressEvent(event);
        _this.addCompressedEventToManager(compressedEvent, sessionId);
      }
    };
    this.terminate = function () {
      var _a;
      (_a = _this.worker) === null || _a === void 0 ? void 0 : _a.terminate();
    };
    var globalScope = getGlobalScope();
    this.canUseIdleCallback = globalScope && 'requestIdleCallback' in globalScope;
    this.eventsManager = eventsManager;
    this.config = config;
    this.deviceId = deviceId;
    this.timeout = ((_a = config.performanceConfig) === null || _a === void 0 ? void 0 : _a.timeout) || DEFAULT_TIMEOUT;
    // These two lines will be changed at compile time.
    var replace = {};
    // This next line is going to be ridiculously hard to cover in unit tests, ignoring.
    /* istanbul ignore next */
    var workerScript = (_b = replace.COMPRESSION_WEBWORKER_BODY) !== null && _b !== void 0 ? _b : workerScriptInternal;
    if (((_c = this.config.experimental) === null || _c === void 0 ? void 0 : _c.useWebWorker) && globalScope && globalScope.Worker && workerScript) {
      config.loggerProvider.log('[Experimental] Enabling web worker for compression');
      var worker = new Worker(URL.createObjectURL(new Blob([workerScript], {
        type: 'application/javascript'
      })));
      worker.onerror = function (e) {
        config.loggerProvider.error(e);
      };
      worker.onmessage = function (e) {
        var _a = e.data,
          compressedEvent = _a.compressedEvent,
          sessionId = _a.sessionId;
        _this.addCompressedEventToManager(compressedEvent, sessionId);
      };
      this.worker = worker;
    }
  }
  // Schedule processing during idle time
  EventCompressor.prototype.scheduleIdleProcessing = function () {
    var _this = this;
    if (!this.isProcessing) {
      this.isProcessing = true;
      requestIdleCallback(function (idleDeadline) {
        _this.processQueue(idleDeadline);
      }, {
        timeout: this.timeout
      });
    }
  };
  // Add an event to the task queue if idle callback is supported or compress the event directly
  EventCompressor.prototype.enqueueEvent = function (event, sessionId) {
    var _a;
    if (this.canUseIdleCallback && ((_a = this.config.performanceConfig) === null || _a === void 0 ? void 0 : _a.enabled)) {
      this.config.loggerProvider.debug('Enqueuing event for processing during idle time.');
      this.taskQueue.push({
        event: event,
        sessionId: sessionId
      });
      this.scheduleIdleProcessing();
    } else {
      this.config.loggerProvider.debug('Processing event without idle callback.');
      this.addCompressedEvent(event, sessionId);
    }
  };
  // Process the task queue during idle time
  EventCompressor.prototype.processQueue = function (idleDeadline) {
    var _this = this;
    // Process tasks while there's idle time or until the max number of tasks is reached
    while (this.taskQueue.length > 0 && (idleDeadline.timeRemaining() > 0 || idleDeadline.didTimeout)) {
      var task = this.taskQueue.shift();
      if (task) {
        var event_1 = task.event,
          sessionId = task.sessionId;
        this.addCompressedEvent(event_1, sessionId);
      }
    }
    // If there are still tasks in the queue, schedule the next idle callback
    if (this.taskQueue.length > 0) {
      requestIdleCallback(function (idleDeadline) {
        _this.processQueue(idleDeadline);
      }, {
        timeout: this.timeout
      });
    } else {
      this.isProcessing = false;
    }
  };
  return EventCompressor;
}();

/**
 * Creates a URL tracking plugin for rrweb record function
 *
 * This plugin monitors URL changes in the browser and emits events when the URL changes.
 * It supports three tracking modes:
 * 1. Polling (if explicitly enabled) - periodically checks for URL changes
 * 2. History API + Hash routing (default) - patches pushState/replaceState, listens to popstate and hashchange
 * 3. Hash routing only (fallback) - listens to hashchange events when History API is unavailable
 *
 * The plugin handles edge cases gracefully:
 * - Missing or null location objects
 * - Undefined, null, or empty location.href values
 * - Temporal dead zone issues with variable declarations
 * - Consistent URL normalization across all code paths
 *
 * @param options Configuration options for URL tracking
 * @returns RecordPlugin instance that can be used with rrweb
 */
function createUrlTrackingPlugin(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'amplitude/url-tracking@1',
    observer: function (cb, globalScope, pluginOptions) {
      var _a, _b, _c;
      // Merge options with plugin-level options taking precedence over constructor options
      var config = _assign$(_assign$({}, options), pluginOptions);
      var ugcFilterRules = config.ugcFilterRules || [];
      var enablePolling = (_a = config.enablePolling) !== null && _a !== void 0 ? _a : false;
      var pollingInterval = (_b = config.pollingInterval) !== null && _b !== void 0 ? _b : DEFAULT_URL_CHANGE_POLLING_INTERVAL;
      var captureDocumentTitle = (_c = config.captureDocumentTitle) !== null && _c !== void 0 ? _c : false;
      // Early return if no global scope is available
      if (!globalScope) {
        return function () {
          // No cleanup needed if no global scope available
        };
      }
      // Track the last URL to prevent duplicate events
      // Initialize to undefined to ensure first call always emits an event
      var lastTrackedUrl = undefined;
      // Helper functions
      /**
       * Gets the current URL with proper normalization
       * Handles edge cases where location.href might be undefined, null, or empty
       * Ensures consistent behavior across all code paths
       * @returns Normalized URL string (empty string if location unavailable)
       */
      var getCurrentUrl = function getCurrentUrl() {
        if (!globalScope.location) return '';
        return globalScope.location.href || '';
      };
      /**
       * Creates a URL change event with current page information
       * Applies UGC filtering if rules are configured
       * Uses getCurrentUrl() for consistent URL normalization
       * @returns URLChangeEvent with current page state
       */
      var createUrlChangeEvent = function createUrlChangeEvent() {
        var innerHeight = globalScope.innerHeight,
          innerWidth = globalScope.innerWidth,
          document = globalScope.document;
        var currentUrl = getCurrentUrl();
        var currentTitle = '';
        if (captureDocumentTitle) {
          currentTitle = (document === null || document === void 0 ? void 0 : document.title) || '';
        }
        // Apply UGC filtering if rules are provided, otherwise use original URL
        var filteredUrl = ugcFilterRules.length > 0 ? getPageUrl(currentUrl, ugcFilterRules) : currentUrl;
        return {
          href: filteredUrl,
          title: currentTitle,
          viewportHeight: innerHeight,
          viewportWidth: innerWidth,
          type: 'url-change-event'
        };
      };
      /**
       * Emits a URL change event if the URL has actually changed
       * Always emits on first call (when lastTrackedUrl is undefined)
       * Prevents duplicate events for the same URL on subsequent calls
       * Handles edge cases like undefined/null/empty URLs gracefully
       */
      var emitUrlChange = function emitUrlChange() {
        var currentUrl = getCurrentUrl();
        // Always emit on first call, or if URL actually changed
        if (lastTrackedUrl === undefined || currentUrl !== lastTrackedUrl) {
          lastTrackedUrl = currentUrl;
          var event_1 = createUrlChangeEvent();
          cb(event_1);
        }
      };
      /**
       * Creates a patched version of history methods (pushState/replaceState)
       * that calls the original method and then emits a URL change event
       * Ensures URL changes are detected even when history methods are called programmatically
       * @param originalMethod The original history method to patch
       * @returns Patched function that calls original method then emits URL change event
       */
      var createHistoryMethodPatch = function createHistoryMethodPatch(originalMethod) {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          // Call the original history method first
          var result = originalMethod.apply(this, args);
          // Then emit URL change event
          emitUrlChange();
          return result;
        };
      };
      // Hashchange event handler - delegates to emitUrlChange for consistency
      var hashChangeHandler = function hashChangeHandler() {
        emitUrlChange();
      };
      // 1. if explicitly enable polling → use polling
      if (enablePolling) {
        // Use polling (covers everything)
        var urlChangeInterval_1 = globalScope.setInterval(function () {
          emitUrlChange();
        }, pollingInterval);
        // Emit initial URL immediately
        emitUrlChange();
        // Return cleanup function to stop polling
        return function () {
          if (urlChangeInterval_1) {
            globalScope.clearInterval(urlChangeInterval_1);
          }
        };
      }
      // 2. if polling not enabled → check history, if exist, use history
      if (globalScope.history) {
        // Use History API + hashchange (covers History API + hash routing)
        // Store original history methods for restoration during cleanup
        var originalPushState_1 = globalScope.history.pushState.bind(globalScope.history);
        var originalReplaceState_1 = globalScope.history.replaceState.bind(globalScope.history);
        /**
         * Sets up history method patching to intercept pushState and replaceState calls
         * This ensures URL changes are detected even when history methods are called programmatically
         */
        var setupHistoryPatching = function setupHistoryPatching() {
          // Patch pushState to emit URL change events
          globalScope.history.pushState = createHistoryMethodPatch(originalPushState_1);
          // Patch replaceState to emit URL change events
          globalScope.history.replaceState = createHistoryMethodPatch(originalReplaceState_1);
        };
        // Apply history method patches
        setupHistoryPatching();
        // Listen to popstate events for browser back/forward navigation
        globalScope.addEventListener('popstate', emitUrlChange);
        // Listen to hashchange events for hash routing
        globalScope.addEventListener('hashchange', hashChangeHandler);
        // Emit initial URL immediately
        emitUrlChange();
        // Return cleanup function to restore original state
        return function () {
          // Restore original history methods
          globalScope.history.pushState = originalPushState_1;
          globalScope.history.replaceState = originalReplaceState_1;
          // Remove popstate event listener
          globalScope.removeEventListener('popstate', emitUrlChange);
          // Remove hashchange event listener
          globalScope.removeEventListener('hashchange', hashChangeHandler);
        };
      }
      // 3. if not, then the framework is probably using hash router → do hash
      // Fallback: just hashchange (for pure hash routing)
      globalScope.addEventListener('hashchange', hashChangeHandler);
      emitUrlChange();
      return function () {
        globalScope.removeEventListener('hashchange', hashChangeHandler);
      };
    },
    options: options
  };
}
/**
 * Default URL tracking plugin instance with default options
 * Can be used directly without custom configuration
 */
createUrlTrackingPlugin();
var SessionReplay = /** @class */function () {
  function SessionReplay() {
    var _this = this;
    this.name = '@amplitude/session-replay-browser';
    this.recordCancelCallback = null;
    this.eventCount = 0;
    // Visible for testing only
    this.pageLeaveFns = [];
    // Cache the dynamically imported record function
    this.recordFunction = null;
    this.teardownEventListeners = function (teardown) {
      var globalScope = getGlobalScope();
      if (globalScope) {
        globalScope.removeEventListener('blur', _this.blurListener);
        globalScope.removeEventListener('focus', _this.focusListener);
        !teardown && globalScope.addEventListener('blur', _this.blurListener);
        !teardown && globalScope.addEventListener('focus', _this.focusListener);
        // prefer pagehide to unload events, this is the standard going forward. it is not
        // 100% reliable, but is bfcache-compatible.
        if (globalScope.self && 'onpagehide' in globalScope.self) {
          globalScope.removeEventListener('pagehide', _this.pageLeaveListener);
          !teardown && globalScope.addEventListener('pagehide', _this.pageLeaveListener);
        } else {
          // this has performance implications, but is the only way we can reliably send events
          // in browser that don't support pagehide.
          globalScope.removeEventListener('beforeunload', _this.pageLeaveListener);
          !teardown && globalScope.addEventListener('beforeunload', _this.pageLeaveListener);
        }
      }
    };
    this.blurListener = function () {
      _this.sendEvents();
    };
    this.focusListener = function () {
      // Restart recording on focus to ensure that when user
      // switches tabs, we take a full snapshot
      void _this.recordEvents(false);
    };
    /**
     * This is an instance member so that if init is called multiple times
     * it doesn't add another listener to the page leave event. This is to
     * prevent duplicate listener actions from firing.
     */
    this.pageLeaveListener = function (e) {
      _this.pageLeaveFns.forEach(function (fn) {
        fn(e);
      });
    };
    this.addCustomRRWebEvent = function (eventName, eventData, addStorageInfo) {
      if (eventData === void 0) {
        eventData = {};
      }
      if (addStorageInfo === void 0) {
        addStorageInfo = true;
      }
      return __awaiter(_this, void 0, void 0, function () {
        var debugInfo, config, storageSizeData, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 3,, 4]);
              debugInfo = undefined;
              config = this.config;
              if (!(config && eventName !== CustomRRwebEvent.METADATA)) return [3 /*break*/, 2];
              debugInfo = {
                config: getDebugConfig(config),
                version: VERSION
              };
              if (!addStorageInfo) return [3 /*break*/, 2];
              return [4 /*yield*/, getStorageSize()];
            case 1:
              storageSizeData = _a.sent();
              debugInfo = _assign$(_assign$({}, storageSizeData), debugInfo);
              _a.label = 2;
            case 2:
              // Check first to ensure we are recording
              if (this.recordCancelCallback && this.recordFunction) {
                this.recordFunction.addCustomEvent(eventName, _assign$(_assign$({}, eventData), debugInfo));
              } else {
                this.loggerProvider.debug("Not able to add custom replay capture event ".concat(eventName, " due to no ongoing recording."));
              }
              return [3 /*break*/, 4];
            case 3:
              e_1 = _a.sent();
              this.loggerProvider.debug('Error while adding custom replay capture event: ', e_1);
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    this.stopRecordingEvents = function () {
      var _a;
      try {
        _this.loggerProvider.log('Session Replay capture stopping.');
        _this.recordCancelCallback && _this.recordCancelCallback();
        _this.recordCancelCallback = null;
        (_a = _this.networkObservers) === null || _a === void 0 ? void 0 : _a.stop();
      } catch (error) {
        var typedError = error;
        _this.loggerProvider.warn("Error occurred while stopping replay capture: ".concat(typedError.toString()));
      }
    };
    this.loggerProvider = new SafeLoggerProvider(new Logger());
  }
  SessionReplay.prototype.init = function (apiKey, options) {
    return returnWrapper(this._init(apiKey, options));
  };
  SessionReplay.prototype._init = function (apiKey, options) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
      var _g, _h, joinedConfig, localConfig, remoteConfig, scrollWatcher, managers, storeType, rrwebEventManager, error_1, typedError, payloadBatcher, interactionEventManager, error_2, typedError;
      return __generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            this.loggerProvider = new SafeLoggerProvider(options.loggerProvider || new Logger());
            Object.prototype.hasOwnProperty.call(options, 'logLevel') && this.loggerProvider.enable(options.logLevel);
            this.identifiers = new SessionIdentifiers({
              sessionId: options.sessionId,
              deviceId: options.deviceId
            });
            _g = this;
            return [4 /*yield*/, createSessionReplayJoinedConfigGenerator(apiKey, options)];
          case 1:
            _g.joinedConfigGenerator = _j.sent();
            return [4 /*yield*/, this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)];
          case 2:
            _h = _j.sent(), joinedConfig = _h.joinedConfig, localConfig = _h.localConfig, remoteConfig = _h.remoteConfig;
            this.config = joinedConfig;
            this.setMetadata(options.sessionId, joinedConfig, localConfig, remoteConfig, (_a = options.version) === null || _a === void 0 ? void 0 : _a.version, VERSION, (_b = options.version) === null || _b === void 0 ? void 0 : _b.type);
            if (options.sessionId && ((_c = this.config.interactionConfig) === null || _c === void 0 ? void 0 : _c.enabled)) {
              scrollWatcher = ScrollWatcher.default({
                sessionId: options.sessionId,
                type: 'interaction'
              }, this.config);
              this.pageLeaveFns = [scrollWatcher.send(this.getDeviceId.bind(this)).bind(scrollWatcher)];
              this.scrollHook = scrollWatcher.hook.bind(scrollWatcher);
            }
            managers = [];
            storeType = this.config.storeType;
            if (storeType === 'idb' && !((_d = getGlobalScope()) === null || _d === void 0 ? void 0 : _d.indexedDB)) {
              storeType = 'memory';
              this.loggerProvider.warn('Could not use preferred indexedDB storage, reverting to in memory option.');
            }
            this.loggerProvider.log("Using ".concat(storeType, " for event storage."));
            _j.label = 3;
          case 3:
            _j.trys.push([3, 5,, 6]);
            return [4 /*yield*/, createEventsManager({
              config: this.config,
              sessionId: this.identifiers.sessionId,
              type: 'replay',
              storeType: storeType
            })];
          case 4:
            rrwebEventManager = _j.sent();
            managers.push({
              name: 'replay',
              manager: rrwebEventManager
            });
            return [3 /*break*/, 6];
          case 5:
            error_1 = _j.sent();
            typedError = error_1;
            this.loggerProvider.warn("Error occurred while creating replay events manager: ".concat(typedError.toString()));
            return [3 /*break*/, 6];
          case 6:
            if (!((_e = this.config.interactionConfig) === null || _e === void 0 ? void 0 : _e.enabled)) return [3 /*break*/, 10];
            payloadBatcher = this.config.interactionConfig.batch ? clickBatcher : clickNonBatcher;
            _j.label = 7;
          case 7:
            _j.trys.push([7, 9,, 10]);
            return [4 /*yield*/, createEventsManager({
              config: this.config,
              sessionId: this.identifiers.sessionId,
              type: 'interaction',
              minInterval: (_f = this.config.interactionConfig.trackEveryNms) !== null && _f !== void 0 ? _f : INTERACTION_MIN_INTERVAL,
              maxInterval: INTERACTION_MAX_INTERVAL,
              payloadBatcher: payloadBatcher,
              storeType: storeType
            })];
          case 8:
            interactionEventManager = _j.sent();
            managers.push({
              name: 'interaction',
              manager: interactionEventManager
            });
            return [3 /*break*/, 10];
          case 9:
            error_2 = _j.sent();
            typedError = error_2;
            this.loggerProvider.warn("Error occurred while creating interaction events manager: ".concat(typedError.toString()));
            return [3 /*break*/, 10];
          case 10:
            this.eventsManager = new (MultiEventManager.bind.apply(MultiEventManager, __spreadArray([void 0], __read$1(managers), false)))();
            // To prevent too many threads.
            if (this.eventCompressor) {
              this.eventCompressor.terminate();
            }
            this.eventCompressor = new EventCompressor(this.eventsManager, this.config, this.getDeviceId());
            return [4 /*yield*/, this.initializeNetworkObservers()];
          case 11:
            _j.sent();
            this.loggerProvider.log('Installing @amplitude/session-replay-browser.');
            this.teardownEventListeners(false);
            void this.initialize(true);
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.setSessionId = function (sessionId, deviceId) {
    return returnWrapper(this.asyncSetSessionId(sessionId, deviceId));
  };
  SessionReplay.prototype.asyncSetSessionId = function (sessionId, deviceId) {
    return __awaiter(this, void 0, void 0, function () {
      var previousSessionId, deviceIdForReplayId, joinedConfig;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            previousSessionId = this.identifiers && this.identifiers.sessionId;
            if (previousSessionId) {
              this.sendEvents(previousSessionId);
            }
            deviceIdForReplayId = deviceId || this.getDeviceId();
            this.identifiers = new SessionIdentifiers({
              sessionId: sessionId,
              deviceId: deviceIdForReplayId
            });
            if (!(this.joinedConfigGenerator && previousSessionId)) return [3 /*break*/, 2];
            return [4 /*yield*/, this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)];
          case 1:
            joinedConfig = _a.sent().joinedConfig;
            this.config = joinedConfig;
            _a.label = 2;
          case 2:
            void this.recordEvents();
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.getSessionReplayProperties = function () {
    var _a;
    var config = this.config;
    var identifiers = this.identifiers;
    if (!config || !identifiers) {
      this.loggerProvider.warn('Session replay init has not been called, cannot get session replay properties.');
      return {};
    }
    var shouldRecord = this.getShouldRecord();
    var eventProperties = {};
    if (shouldRecord) {
      eventProperties = (_a = {}, _a[DEFAULT_SESSION_REPLAY_PROPERTY] = identifiers.sessionReplayId ? identifiers.sessionReplayId : null, _a);
      if (config.debugMode) {
        eventProperties[SESSION_REPLAY_DEBUG_PROPERTY] = JSON.stringify({
          appHash: generateHashCode(config.apiKey).toString()
        });
      }
    }
    void this.addCustomRRWebEvent(CustomRRwebEvent.GET_SR_PROPS, {
      shouldRecord: shouldRecord,
      eventProperties: eventProperties
    }, this.eventCount === 10);
    if (this.eventCount === 10) {
      this.eventCount = 0;
    }
    this.eventCount++;
    return eventProperties;
  };
  SessionReplay.prototype.sendEvents = function (sessionId) {
    var _a;
    var sessionIdToSend = sessionId || ((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId);
    var deviceId = this.getDeviceId();
    this.eventsManager && sessionIdToSend && deviceId && this.eventsManager.sendCurrentSequenceEvents({
      sessionId: sessionIdToSend,
      deviceId: deviceId
    });
  };
  SessionReplay.prototype.initialize = function (shouldSendStoredEvents) {
    var _a;
    if (shouldSendStoredEvents === void 0) {
      shouldSendStoredEvents = false;
    }
    return __awaiter(this, void 0, void 0, function () {
      var deviceId;
      return __generator(this, function (_b) {
        if (!((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId)) {
          this.loggerProvider.log("Session is not being recorded due to lack of session id.");
          return [2 /*return*/, Promise.resolve()];
        }
        deviceId = this.getDeviceId();
        if (!deviceId) {
          this.loggerProvider.log("Session is not being recorded due to lack of device id.");
          return [2 /*return*/, Promise.resolve()];
        }
        this.eventsManager && shouldSendStoredEvents && void this.eventsManager.sendStoredEvents({
          deviceId: deviceId
        });
        return [2 /*return*/, this.recordEvents()];
      });
    });
  };
  SessionReplay.prototype.shouldOptOut = function () {
    var _a, _b;
    var identityStoreOptOut;
    if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceName) {
      var identityStore = getAnalyticsConnector(this.config.instanceName).identityStore;
      identityStoreOptOut = identityStore.getIdentity().optOut;
    }
    return identityStoreOptOut !== undefined ? identityStoreOptOut : (_b = this.config) === null || _b === void 0 ? void 0 : _b.optOut;
  };
  SessionReplay.prototype.getShouldRecord = function () {
    if (!this.identifiers || !this.config || !this.identifiers.sessionId) {
      this.loggerProvider.warn("Session is not being recorded due to lack of config, please call sessionReplay.init.");
      return false;
    }
    if (!this.config.captureEnabled) {
      this.loggerProvider.log("Session ".concat(this.identifiers.sessionId, " not being captured due to capture being disabled for project or because the remote config could not be fetched."));
      return false;
    }
    if (this.shouldOptOut()) {
      this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to optOut config."));
      return false;
    }
    var isInSample = isSessionInSample(this.identifiers.sessionId, this.config.sampleRate);
    if (!isInSample) {
      this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to sample rate."));
    }
    return isInSample;
  };
  SessionReplay.prototype.getBlockSelectors = function () {
    var _a, _b, _c;
    // For some reason, this defaults to empty array ([]) if undefined in the compiled script.
    // Empty arrays cause errors when being evaluated in Safari.
    // Force the selector to be undefined if it's an empty array.
    var blockSelector = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.blockSelector) !== null && _c !== void 0 ? _c : [];
    if (blockSelector.length === 0) {
      return undefined;
    }
    return blockSelector;
  };
  SessionReplay.prototype.getMaskTextSelectors = function () {
    var _a, _b, _c, _d;
    if (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.defaultMaskLevel) === 'conservative') {
      return '*';
    }
    var maskSelector = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.privacyConfig) === null || _d === void 0 ? void 0 : _d.maskSelector;
    if (!maskSelector) {
      return;
    }
    return maskSelector;
  };
  SessionReplay.prototype.getRecordingPlugins = function (loggingConfig) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
      var plugins, urlTrackingPlugin, getRecordConsolePlugin, error_3;
      return __generator(this, function (_g) {
        switch (_g.label) {
          case 0:
            plugins = [];
            // Add URL tracking plugin
            try {
              urlTrackingPlugin = createUrlTrackingPlugin({
                ugcFilterRules: ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.interactionConfig) === null || _b === void 0 ? void 0 : _b.ugcFilterRules) || [],
                enablePolling: ((_c = this.config) === null || _c === void 0 ? void 0 : _c.enableUrlChangePolling) || false,
                pollingInterval: (_d = this.config) === null || _d === void 0 ? void 0 : _d.urlChangePollingInterval,
                captureDocumentTitle: (_e = this.config) === null || _e === void 0 ? void 0 : _e.captureDocumentTitle
              });
              plugins.push(urlTrackingPlugin);
            } catch (error) {
              this.loggerProvider.warn('Failed to create URL tracking plugin:', error);
            }
            if (!((_f = loggingConfig === null || loggingConfig === void 0 ? void 0 : loggingConfig.console) === null || _f === void 0 ? void 0 : _f.enabled)) return [3 /*break*/, 4];
            _g.label = 1;
          case 1:
            _g.trys.push([1, 3,, 4]);
            return [4 /*yield*/, import('./rrweb-plugin-console-record-Cm_HrN9C.js')];
          case 2:
            getRecordConsolePlugin = _g.sent().getRecordConsolePlugin;
            plugins.push(getRecordConsolePlugin({
              level: loggingConfig.console.levels
            }));
            return [3 /*break*/, 4];
          case 3:
            error_3 = _g.sent();
            this.loggerProvider.warn('Failed to load console plugin:', error_3);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/, plugins.length > 0 ? plugins : undefined];
        }
      });
    });
  };
  SessionReplay.prototype.getRecordFunction = function () {
    return __awaiter(this, void 0, void 0, function () {
      var record, error_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.recordFunction) {
              return [2 /*return*/, this.recordFunction];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, import('./rrweb-record-BFoGru_H.js')];
          case 2:
            record = _a.sent().record;
            this.recordFunction = record;
            return [2 /*return*/, record];
          case 3:
            error_4 = _a.sent();
            this.loggerProvider.warn('Failed to load rrweb-record module:', error_4);
            return [2 /*return*/, null];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.recordEvents = function (shouldLogMetadata) {
    var _a, _b, _c, _d, _e;
    if (shouldLogMetadata === void 0) {
      shouldLogMetadata = true;
    }
    return __awaiter(this, void 0, void 0, function () {
      var config, shouldRecord, sessionId, recordFunction, privacyConfig, interactionConfig, loggingConfig, hooks, ugcFilterRules, _f, _g, error_5;
      var _h;
      var _this = this;
      return __generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            config = this.config;
            shouldRecord = this.getShouldRecord();
            sessionId = (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
            if (!shouldRecord || !sessionId || !config) {
              return [2 /*return*/];
            }
            this.stopRecordingEvents();
            return [4 /*yield*/, this.getRecordFunction()];
          case 1:
            recordFunction = _j.sent();
            // May be undefined if cannot import rrweb-record
            if (!recordFunction) {
              return [2 /*return*/];
            }
            return [4 /*yield*/, this.initializeNetworkObservers()];
          case 2:
            _j.sent();
            (_b = this.networkObservers) === null || _b === void 0 ? void 0 : _b.start(function (event) {
              void _this.addCustomRRWebEvent(CustomRRwebEvent.FETCH_REQUEST, event);
            });
            privacyConfig = config.privacyConfig, interactionConfig = config.interactionConfig, loggingConfig = config.loggingConfig;
            hooks = (interactionConfig === null || interactionConfig === void 0 ? void 0 : interactionConfig.enabled) ? {
              mouseInteraction: this.eventsManager && clickHook(this.loggerProvider, {
                eventsManager: this.eventsManager,
                sessionId: sessionId,
                deviceIdFn: this.getDeviceId.bind(this),
                mirror: recordFunction.mirror,
                ugcFilterRules: (_c = interactionConfig.ugcFilterRules) !== null && _c !== void 0 ? _c : []
              }),
              scroll: this.scrollHook
            } : {};
            ugcFilterRules = (interactionConfig === null || interactionConfig === void 0 ? void 0 : interactionConfig.enabled) && interactionConfig.ugcFilterRules ? interactionConfig.ugcFilterRules : [];
            this.loggerProvider.log("Session Replay capture beginning for ".concat(sessionId, "."));
            _j.label = 3;
          case 3:
            _j.trys.push([3, 5,, 6]);
            _f = this;
            _g = recordFunction;
            _h = {
              emit: function (event) {
                if (_this.shouldOptOut()) {
                  _this.loggerProvider.log("Opting session ".concat(sessionId, " out of recording due to optOut config."));
                  _this.stopRecordingEvents();
                  _this.sendEvents();
                  return;
                }
                if (event.type === EventType.Meta) {
                  event.data.href = getPageUrl(event.data.href, ugcFilterRules);
                }
                if (_this.eventCompressor) {
                  // Schedule processing during idle time if the browser supports requestIdleCallback
                  _this.eventCompressor.enqueueEvent(event, sessionId);
                }
              },
              inlineStylesheet: config.shouldInlineStylesheet,
              hooks: hooks,
              maskAllInputs: true,
              maskTextClass: MASK_TEXT_CLASS,
              blockClass: BLOCK_CLASS,
              blockSelector: this.getBlockSelectors(),
              applyBackgroundColorToBlockedElements: config.applyBackgroundColorToBlockedElements,
              maskInputFn: maskFn('input', privacyConfig),
              maskTextFn: maskFn('text', privacyConfig),
              maskTextSelector: this.getMaskTextSelectors(),
              recordCanvas: false,
              slimDOMOptions: {
                script: (_d = config.omitElementTags) === null || _d === void 0 ? void 0 : _d.script,
                comment: (_e = config.omitElementTags) === null || _e === void 0 ? void 0 : _e.comment
              },
              errorHandler: function (error) {
                var typedError = error;
                // styled-components relies on this error being thrown and bubbled up, rrweb is otherwise suppressing it
                if (typedError.message.includes('insertRule') && typedError.message.includes('CSSStyleSheet')) {
                  throw typedError;
                }
                // rrweb does monkey patching on certain window functions such as CSSStyleSheet.proptype.insertRule,
                // and errors from external clients calling these functions can get suppressed. Styled components depend
                // on these errors being re-thrown.
                if (typedError._external_) {
                  throw typedError;
                }
                _this.loggerProvider.warn('Error while capturing replay: ', typedError.toString());
                // Return true so that we don't clutter user's consoles with internal rrweb errors
                return true;
              }
            };
            return [4 /*yield*/, this.getRecordingPlugins(loggingConfig)];
          case 4:
            _f.recordCancelCallback = _g.apply(void 0, [(_h.plugins = _j.sent(), _h)]);
            void this.addCustomRRWebEvent(CustomRRwebEvent.DEBUG_INFO);
            if (shouldLogMetadata) {
              void this.addCustomRRWebEvent(CustomRRwebEvent.METADATA, this.metadata);
            }
            return [3 /*break*/, 6];
          case 5:
            error_5 = _j.sent();
            this.loggerProvider.warn('Failed to initialize session replay:', error_5);
            return [3 /*break*/, 6];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };
  SessionReplay.prototype.getDeviceId = function () {
    var _a;
    return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.deviceId;
  };
  SessionReplay.prototype.getSessionId = function () {
    var _a;
    return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
  };
  SessionReplay.prototype.flush = function (useRetry) {
    var _a;
    if (useRetry === void 0) {
      useRetry = false;
    }
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_b) {
        return [2 /*return*/, (_a = this.eventsManager) === null || _a === void 0 ? void 0 : _a.flush(useRetry)];
      });
    });
  };
  SessionReplay.prototype.shutdown = function () {
    this.teardownEventListeners(true);
    this.stopRecordingEvents();
    this.sendEvents();
  };
  SessionReplay.prototype.mapSDKType = function (sdkType) {
    if (sdkType === 'plugin') {
      return '@amplitude/plugin-session-replay-browser';
    }
    if (sdkType === 'segment') {
      return '@amplitude/segment-session-replay-plugin';
    }
    return null;
  };
  SessionReplay.prototype.setMetadata = function (sessionId, joinedConfig, localConfig, remoteConfig, replaySDKVersion, standaloneSDKVersion, sdkType) {
    var hashValue = (sessionId === null || sessionId === void 0 ? void 0 : sessionId.toString()) ? generateHashCode(sessionId.toString()) : undefined;
    this.metadata = {
      joinedConfig: joinedConfig,
      localConfig: localConfig,
      remoteConfig: remoteConfig,
      sessionId: sessionId,
      hashValue: hashValue,
      sampleRate: joinedConfig.sampleRate,
      replaySDKType: this.mapSDKType(sdkType),
      replaySDKVersion: replaySDKVersion,
      standaloneSDKType: '@amplitude/session-replay-browser',
      standaloneSDKVersion: standaloneSDKVersion
    };
  };
  SessionReplay.prototype.initializeNetworkObservers = function () {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
      var NetworkObserversClass, error_6;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!(((_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.loggingConfig) === null || _b === void 0 ? void 0 : _b.network) === null || _c === void 0 ? void 0 : _c.enabled) && !this.networkObservers)) return [3 /*break*/, 4];
            _d.label = 1;
          case 1:
            _d.trys.push([1, 3,, 4]);
            return [4 /*yield*/, import('./observers-C1Ao9RGC.js')];
          case 2:
            NetworkObserversClass = _d.sent().NetworkObservers;
            this.networkObservers = new NetworkObserversClass();
            return [3 /*break*/, 4];
          case 3:
            error_6 = _d.sent();
            this.loggerProvider.warn('Failed to import or instantiate NetworkObservers:', error_6);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  return SessionReplay;
}();
var getLogConfig = function getLogConfig(sessionReplay) {
  return function () {
    var config = sessionReplay.config;
    var _a = config || getDefaultConfig(),
      logger = _a.loggerProvider,
      logLevel = _a.logLevel;
    return {
      logger: logger,
      logLevel: logLevel
    };
  };
};
var createInstance = function createInstance() {
  var sessionReplay = new SessionReplay();
  return {
    init: debugWrapper(sessionReplay.init.bind(sessionReplay), 'init', getLogConfig(sessionReplay)),
    setSessionId: debugWrapper(sessionReplay.setSessionId.bind(sessionReplay), 'setSessionId', getLogConfig(sessionReplay)),
    getSessionId: debugWrapper(sessionReplay.getSessionId.bind(sessionReplay), 'getSessionId', getLogConfig(sessionReplay)),
    getSessionReplayProperties: debugWrapper(sessionReplay.getSessionReplayProperties.bind(sessionReplay), 'getSessionReplayProperties', getLogConfig(sessionReplay)),
    flush: debugWrapper(sessionReplay.flush.bind(sessionReplay), 'flush', getLogConfig(sessionReplay)),
    shutdown: debugWrapper(sessionReplay.shutdown.bind(sessionReplay), 'shutdown', getLogConfig(sessionReplay))
  };
};
var sessionReplay = createInstance();
var init = sessionReplay.init,
  setSessionId = sessionReplay.setSessionId,
  getSessionId = sessionReplay.getSessionId,
  getSessionReplayProperties = sessionReplay.getSessionReplayProperties,
  flush = sessionReplay.flush,
  shutdown = sessionReplay.shutdown;
export { SafeLoggerProvider as S, __awaiter as _, __generator as a, getSessionId as b, getSessionReplayProperties as c, shutdown as d, flush as f, getGlobalScope as g, init as i, setSessionId as s };